import globalAxios from 'axios';
import * as _ from 'lodash';
import moment from 'moment';
import 'numeral';
import 'slugify';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/* tslint:disable */
const BASE_PATH = "http://localhost".replace(/\/+$/, "");
/**
 *
 * @export
 * @class BaseAPI
 */
class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, axios = globalAxios) {
        var _a;
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = (_a = configuration.basePath) !== null && _a !== void 0 ? _a : basePath;
        }
    }
}
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
/**
 *
 * @export
 */
const operationServerMap = {};

/* tslint:disable */
/**
 *
 * @export
 */
const DUMMY_BASE_URL = 'https://example.com';
/**
 *
 * @throws {RequiredError}
 * @export
 */
const assertParamExists = function (functionName, paramName, paramValue) {
    if (paramValue === null || paramValue === undefined) {
        throw new RequiredError(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
    }
};
function setFlattenedQueryParams(urlSearchParams, parameter, key = "") {
    if (parameter == null)
        return;
    if (typeof parameter === "object") {
        if (Array.isArray(parameter)) {
            parameter.forEach(item => setFlattenedQueryParams(urlSearchParams, item, key));
        }
        else {
            Object.keys(parameter).forEach(currentKey => setFlattenedQueryParams(urlSearchParams, parameter[currentKey], `${key}${key !== '' ? '.' : ''}${currentKey}`));
        }
    }
    else {
        if (urlSearchParams.has(key)) {
            urlSearchParams.append(key, parameter);
        }
        else {
            urlSearchParams.set(key, parameter);
        }
    }
}
/**
 *
 * @export
 */
const setSearchParams = function (url, ...objects) {
    const searchParams = new URLSearchParams(url.search);
    setFlattenedQueryParams(searchParams, objects);
    url.search = searchParams.toString();
};
/**
 *
 * @export
 */
const serializeDataIfNeeded = function (value, requestOptions, configuration) {
    const nonString = typeof value !== 'string';
    const needsSerialization = nonString && configuration && configuration.isJsonMime
        ? configuration.isJsonMime(requestOptions.headers['Content-Type'])
        : nonString;
    return needsSerialization
        ? JSON.stringify(value !== undefined ? value : {})
        : (value || "");
};
/**
 *
 * @export
 */
const toPathString = function (url) {
    return url.pathname + url.search + url.hash;
};
/**
 *
 * @export
 */
const createRequestFunction = function (axiosArgs, globalAxios, BASE_PATH, configuration) {
    return (axios = globalAxios, basePath = BASE_PATH) => {
        var _a;
        const axiosRequestArgs = Object.assign(Object.assign({}, axiosArgs.options), { url: (axios.defaults.baseURL ? '' : (_a = configuration === null || configuration === void 0 ? void 0 : configuration.basePath) !== null && _a !== void 0 ? _a : basePath) + axiosArgs.url });
        return axios.request(axiosRequestArgs);
    };
};

/* tslint:disable */
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {any} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminHackyDevFnsPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/hacky-dev-fns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminInfraCostsByClientGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/admin/infra-costs-by-client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetCrossingTimesByArticleRequest} [getCrossingTimesByArticleRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsCrossingTimesByArticlePost: (getCrossingTimesByArticleRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/analytics/crossing-times-by-article`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getCrossingTimesByArticleRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsCrossingTimesPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/analytics/crossing-times`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AnalyticsOfsEndTimeRequest} [analyticsOfsEndTimeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEndTimePost: (analyticsOfsEndTimeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/analytics/end-time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(analyticsOfsEndTimeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AnalyticsFiltersRequest} [analyticsFiltersRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsFiltersPost: (analyticsFiltersRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/analytics/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(analyticsFiltersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetOPsByOFRequest} [getOPsByOFRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsGetOpsByOfPost: (getOPsByOFRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/analytics/get-ops-by-of`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getOPsByOFRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AnalyticsOFRequest} [analyticsOFRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsOfsPost: (analyticsOFRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/analytics/ofs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(analyticsOFRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AnalyticsProgressRequest} [analyticsProgressRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsProgressPost: (analyticsProgressRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/analytics/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(analyticsProgressRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AnalyticsStagnationRequest} [analyticsStagnationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsStagnationPost: (analyticsStagnationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/analytics/stagnation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(analyticsStagnationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AnalyticsOfsStartedOnTimeRequest} [analyticsOfsStartedOnTimeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsStartedOnTimePost: (analyticsOfsStartedOnTimeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/analytics/started-on-time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(analyticsOfsStartedOnTimeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AnalyticsWIPRequest} [analyticsWIPRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsWipPost: (analyticsWIPRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/analytics/wip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(analyticsWIPRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RecoverImportPostRequest} [recoverImportPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArchivesRecoverImportPost: (recoverImportPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/archives/recover-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(recoverImportPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RecoverSimulationPostRequest} [recoverSimulationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArchivesRecoverSimulationPost: (recoverSimulationPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/archives/recover-simulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(recoverSimulationPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ArticlesGetRequest} [articlesGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlePost: (articlesGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/article`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(articlesGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ArticlesGetRequest} [articlesGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticleTargetStockPost: (articlesGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/article/target_stock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(articlesGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetWorkdaysPostRequest} [getWorkdaysPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalendarGetWorkdaysPost: (getWorkdaysPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/calendar/get-workdays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getWorkdaysPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SaveCalendarRequest} [saveCalendarRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalendarSaveCalendarPost: (saveCalendarRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/calendar/save-calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveCalendarRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalendarTestPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/calendar-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CalculateCapaRequest} [calculateCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesCalculateCapaPost: (calculateCapaRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/capacities/calculate-capa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(calculateCapaRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DailyCapacityRequest} [dailyCapacityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesDailyPost: (dailyCapacityRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/capacities/daily`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dailyCapacityRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DailyTotalCapaRequest} [dailyTotalCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesDailyTotalCapaPost: (dailyTotalCapaRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/capacities/daily_total_capa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dailyTotalCapaRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {FullTimeNeedRequest} [fullTimeNeedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesFullTimeNeedPost: (fullTimeNeedRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/capacities/full-time-need`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(fullTimeNeedRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {NeededOrgaRequest} [neededOrgaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesNeededOrgaPost: (neededOrgaRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/capacities/needed-orga`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(neededOrgaRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OverloadedSectorsRequest} [overloadedSectorsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesOverloadedSectorsPost: (overloadedSectorsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/capacities/overloaded-sectors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(overloadedSectorsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {TotalCapaRequest} [totalCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesTotalCapaPost: (totalCapaRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/capacities/total_capa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(totalCapaRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {TotalRemainingCapaRequest} [totalRemainingCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesTotalRemainingCapaPost: (totalRemainingCapaRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/capacities/total_remaining_capa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(totalRemainingCapaRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ClientsCreateRequest} [clientsCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsPost: (clientsCreateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clientsCreateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CrispHasNewProductReleaseRequest} [crispHasNewProductReleaseRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsCrispHasNewProductReleasePost: (crispHasNewProductReleaseRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/crisp/has-new-product-release`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(crispHasNewProductReleaseRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsCrispWebhooksPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/crisp/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CapaBySectorRequest} [capaBySectorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsExternalCapaBySectorPost: (capaBySectorRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/external/capa-by-sector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(capaBySectorRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsExternalSectorsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/external/sectors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AddCyclePostRequest} [addCyclePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearAddCyclePost: (addCyclePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/linear/add-cycle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addCyclePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearListCyclesPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/linear/list-cycles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CycleIdRequest} [cycleIdRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearLoadCycleDataPost: (cycleIdRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/linear/load-cycle-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cycleIdRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SupportDateRangeRequest} [supportDateRangeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearLoadSupportDataPost: (supportDateRangeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/linear/load-support-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(supportDateRangeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SaveTeamDataPointRequest} [saveTeamDataPointRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearSaveTeamDataPointPost: (saveTeamDataPointRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/linear/save-team-data-point`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveTeamDataPointRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {LinearTechKPIsPostRequest} [linearTechKPIsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearTechKpisPost: (linearTechKPIsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/linear/tech-kpis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(linearTechKPIsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearTimeCalculatorPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/linear/time-calculator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearUpdateLabelsPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/linear/update_labels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearWebhooksPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/linear/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {M3ExtractionRequest} [m3ExtractionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsM3ExtractDataPost: (m3ExtractionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/connectors/m3/extract-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(m3ExtractionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetCustomersDetailsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/customer-interface/get-customers-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetFiltersGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/customer-interface/get-filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CustomerInterfaceGetOfsDetailsRequest} [customerInterfaceGetOfsDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetOfsDetailsPost: (customerInterfaceGetOfsDetailsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/customer-interface/get-ofs-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(customerInterfaceGetOfsDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetProviderIdsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/customer-interface/get-provider-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CustomerInterfaceListOfsGetRequest} [customerInterfaceListOfsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceListOfsPost: (customerInterfaceListOfsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/customer-interface/list-ofs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(customerInterfaceListOfsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DailyDelaysGetRequest} [dailyDelaysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDailyDelaysPost: (dailyDelaysGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/daily-delays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dailyDelaysGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DelaysBySectorGetRequest} [delaysBySectorGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDelaysPost: (delaysBySectorGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/delays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(delaysBySectorGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EventsGetRequest} [eventsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsDetailsPost: (eventsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/events/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(eventsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EventsFieldsGetRequest} [eventsFieldsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsFieldsPost: (eventsFieldsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/events/fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(eventsFieldsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EventsGetSimpleEventsPostRequest} [eventsGetSimpleEventsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsGetSimpleEventsPost: (eventsGetSimpleEventsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/events/get-simple-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(eventsGetSimpleEventsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EventsMigratePostRequest} [eventsMigratePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsMigratePost: (eventsMigratePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/events/migrate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(eventsMigratePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsOnChangePost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/events/on_change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsOnChangeSsePost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/events/on_change_sse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {any | Array<any>} [anyArrayany]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsPushPost: (anyArrayany, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/events/push`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(anyArrayany, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqCheckConnectionGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/fabriq/check_connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqCreateTicketTicketIdPost: (ticketId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('apiFabriqCreateTicketTicketIdPost', 'ticketId', ticketId);
            const localVarPath = `/api/fabriq/create_ticket/{ticketId}`
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqDeleteTicketTicketIdPost: (ticketId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('apiFabriqDeleteTicketTicketIdPost', 'ticketId', ticketId);
            const localVarPath = `/api/fabriq/delete_ticket/{ticketId}`
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqGetTicketTicketIdGet: (ticketId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('apiFabriqGetTicketTicketIdGet', 'ticketId', ticketId);
            const localVarPath = `/api/fabriq/get_ticket/{ticketId}`
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqGetUsersGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/fabriq/get_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GammesGetRequest} [gammesGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGammesPost: (gammesGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/gammes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(gammesGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetDownloadURLRequest} [getDownloadURLRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetDownloadUrlPost: (getDownloadURLRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/get-download-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getDownloadURLRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ImportsDetailedInitialStocksRequest} [importsDetailedInitialStocksRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsDetailedInitialStocksPost: (importsDetailedInitialStocksRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/imports/detailed-initial-stocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importsDetailedInitialStocksRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ImportErrorLogsRequestBody} [importErrorLogsRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsErrorLogsPost: (importErrorLogsRequestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/imports/error-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importErrorLogsRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ImportsFieldsKeysGetRequest} [importsFieldsKeysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsFieldsKeysPost: (importsFieldsKeysGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/imports/fields/keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importsFieldsKeysGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ImportsGenerateFileRequest} [importsGenerateFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsGenerateImportFilePost: (importsGenerateFileRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/imports/generate-import-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importsGenerateFileRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetImportUnitsRequest} [getImportUnitsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsGetImportUnitsPost: (getImportUnitsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/imports/get-import-units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getImportUnitsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} importId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdArticlesRefsPost: (importId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiImportsImportIdArticlesRefsPost', 'importId', importId);
            const localVarPath = `/api/imports/{import_id}/articles/refs`
                .replace(`{${"import_id"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} importId
         * @param {ImportsDailyRawLoadsGetRequest} [importsDailyRawLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdDailyRawLoadsPost: (importId, importsDailyRawLoadsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiImportsImportIdDailyRawLoadsPost', 'importId', importId);
            const localVarPath = `/api/imports/{import_id}/daily-raw-loads`
                .replace(`{${"import_id"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importsDailyRawLoadsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} importId
         * @param {ImportsSpecificLoadsGetRequest} [importsSpecificLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdLoadsPost: (importId, importsSpecificLoadsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiImportsImportIdLoadsPost', 'importId', importId);
            const localVarPath = `/api/imports/{import_id}/loads`
                .replace(`{${"import_id"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importsSpecificLoadsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} importId
         * @param {string} ofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdOfsOfIdLastDateGet: (importId, ofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiImportsImportIdOfsOfIdLastDateGet', 'importId', importId);
            // verify required parameter 'ofId' is not null or undefined
            assertParamExists('apiImportsImportIdOfsOfIdLastDateGet', 'ofId', ofId);
            const localVarPath = `/api/imports/{import_id}/ofs/{of_id}/last-date`
                .replace(`{${"import_id"}}`, encodeURIComponent(String(importId)))
                .replace(`{${"of_id"}}`, encodeURIComponent(String(ofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ImportLogsRequestBody} [importLogsRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportLogsPost: (importLogsRequestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/imports/import-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importLogsRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ImportsInitialStocksRequest} [importsInitialStocksRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsInitialStocksPost: (importsInitialStocksRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/imports/initial-stocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importsInitialStocksRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ImportsLastRequest} [importsLastRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsLastPost: (importsLastRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/imports/last`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importsLastRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ImportsLateRequest} [importsLateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsLatePost: (importsLateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/imports/late`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importsLateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ImportsLoadsGetRequest} [importsLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsLoadsPost: (importsLoadsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/imports/loads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importsLoadsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ImportsSkippedRequest} [importsSkippedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsSkippedPost: (importsSkippedRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/imports/skipped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(importsSkippedRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {LaunchPgMigrateRequest} [launchPgMigrateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLaunchPgMigratePost: (launchPgMigrateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/launch-pg-migrate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(launchPgMigrateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetAbsencesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/mercateam/get_absences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetEmployeesListGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/mercateam/get_employees_list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetPlanningsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/mercateam/get_plannings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetSectorsPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/mercateam/get_sectors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetStatusGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/mercateam/get_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamSavePlanningsPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/mercateam/save_plannings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamSaveUnexpectedEventsPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/mercateam/save_unexpected_events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DbHelperProxyPostRequest} [dbHelperProxyPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationDbhelperProxyPost: (dbHelperProxyPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/migration/dbhelper-proxy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dbHelperProxyPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {MigrateToTargetPostRequest} [migrateToTargetPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationMigrateToTargetPost: (migrateToTargetPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/migration/migrate-to-target`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(migrateToTargetPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PGProxyPostRequest} [pGProxyPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationPgProxyPost: (pGProxyPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/migration/pg-proxy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(pGProxyPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNomenclaturesGetAllGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/nomenclatures/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {NomenclaturesPostRequestUpdate} [nomenclaturesPostRequestUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNomenclaturesUpdatePost: (nomenclaturesPostRequestUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/nomenclatures/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(nomenclaturesPostRequestUpdate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OplitCopilotTriggerCopilotReschedulingPostRequest} [oplitCopilotTriggerCopilotReschedulingPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitCopilotTriggerCopilotRescheduling: (oplitCopilotTriggerCopilotReschedulingPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-copilot/trigger-copilot-rescheduling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(oplitCopilotTriggerCopilotReschedulingPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OplitDateGetCsvWithOplitDatePostRequest} [oplitDateGetCsvWithOplitDatePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGenerateCSVDoneOFsHistory: (oplitDateGetCsvWithOplitDatePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-date/generate-csv-done-ofs-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(oplitDateGetCsvWithOplitDatePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OplitDateGetCsvWithOplitDatePostRequest} [oplitDateGetCsvWithOplitDatePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGenerateCSVOngoingOFsEstimations: (oplitDateGetCsvWithOplitDatePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-date/generate-csv-ongoing-ofs-estimations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(oplitDateGetCsvWithOplitDatePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetClientFeatures: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-date/get-client-features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetClientOFs: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-date/get-client-ofs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetClientTeamSettings: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-date/get-client-team-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OplitDateGetCsvWithOfHistoryPostRequest} [oplitDateGetCsvWithOfHistoryPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetCsvWithOfHistory: (oplitDateGetCsvWithOfHistoryPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-date/generate-csv-of-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(oplitDateGetCsvWithOfHistoryPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetImpactedScopes: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-date/get-impacted-scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetLastUpdate: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-date/get-last-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OplitDateSaveClientFeaturesPostRequest} [oplitDateSaveClientFeaturesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateSaveClientFeatures: (oplitDateSaveClientFeaturesPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-date/save-client-features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(oplitDateSaveClientFeaturesPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OplitDateSaveOplitDateTeamSettingsPostRequest} [oplitDateSaveOplitDateTeamSettingsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateSaveOplitDateTeamSettings: (oplitDateSaveOplitDateTeamSettingsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-date/save-oplit-date-team-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(oplitDateSaveOplitDateTeamSettingsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PdpLoadGetInitialLoadsRequest} [pdpLoadGetInitialLoadsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadGetInitialLoadsPost: (pdpLoadGetInitialLoadsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/pdp_load/get-initial-loads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(pdpLoadGetInitialLoadsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PdpLoadGetLoadEventsRequest} [pdpLoadGetLoadEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadGetLoadEventsPost: (pdpLoadGetLoadEventsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/pdp_load/get-load-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(pdpLoadGetLoadEventsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PdpLoadGetSectorChargePostRequest} [pdpLoadGetSectorChargePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadGetSectorChargePost: (pdpLoadGetSectorChargePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/pdp_load/get-sector-charge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(pdpLoadGetSectorChargePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadHasSectorChargeFormulaGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/pdp_load/has-sector-charge-formula`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PdpLoadSaveLoadEventRequest} [pdpLoadSaveLoadEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadSaveLoadEventPost: (pdpLoadSaveLoadEventRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/pdp_load/save-load-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(pdpLoadSaveLoadEventRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PdpLoadUpdateLoadEventRequest} [pdpLoadUpdateLoadEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadUpdateLoadEventPost: (pdpLoadUpdateLoadEventRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/pdp_load/update-load-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(pdpLoadUpdateLoadEventRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PgTriggersPostRequest} [pgTriggersPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPgTriggersPost: (pgTriggersPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/pg-triggers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(pgTriggersPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AbsencesByOperatorRequest} [absencesByOperatorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningAbsencesByOperatorPost: (absencesByOperatorRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/planning/absences_by_operator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(absencesByOperatorRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DailyPlanningRequest} [dailyPlanningRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningDailyPlanningPost: (dailyPlanningRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/planning/daily_planning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dailyPlanningRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {IsGoulotRequest} [isGoulotRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningIsGoulotPost: (isGoulotRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/planning/is_goulot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(isGoulotRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {MachinesByOperatorRequest} [machinesByOperatorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningMachinesByOperatorPost: (machinesByOperatorRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/planning/machines_by_operator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(machinesByOperatorRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {MachinesBySectorRequest} [machinesBySectorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningMachinesBySectorPost: (machinesBySectorRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/planning/machines_by_sector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(machinesBySectorRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CustomMSDFieldValueRequest} [customMSDFieldValueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningMsdFieldValuePost: (customMSDFieldValueRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/planning/msd_field_value`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(customMSDFieldValueRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OperatorsByMachineRequest} [operatorsByMachineRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningOperatorsByMachinePost: (operatorsByMachineRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/planning/operators_by_machine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(operatorsByMachineRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OperatorsBySectorRequest} [operatorsBySectorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningOperatorsBySectorPost: (operatorsBySectorRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/planning/operators_by_sector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(operatorsBySectorRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PeriodesOrgaRequest} [periodesOrgaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningPeriodesOrgaPost: (periodesOrgaRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/planning/periodes_orga`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(periodesOrgaRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SaveStandardPlanningRequest} [saveStandardPlanningRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningSaveStandardPlanningPost: (saveStandardPlanningRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/planning/save-standard-planning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveStandardPlanningRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ProductionsAllGetRequest} [productionsAllGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionsAllPost: (productionsAllGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/productions/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productionsAllGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ProductionsLastProdUpdateGetRequest} [productionsLastProdUpdateGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionsLastProdUpdatePost: (productionsLastProdUpdateGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/productions/last_prod_update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(productionsLastProdUpdateGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPubsubPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/pubsub`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingAiPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/ai`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingCancelLastSchedulingAIRequest} [schedulingCancelLastSchedulingAIRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingCancelLastReschedulingAiPost: (schedulingCancelLastSchedulingAIRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/cancel_last_rescheduling_ai`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingCancelLastSchedulingAIRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingGetConwipTicketsGaugesPostRequest} [schedulingGetConwipTicketsGaugesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetConwipTicketsGaugesPost: (schedulingGetConwipTicketsGaugesPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/get-conwip-tickets-gauges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingGetConwipTicketsGaugesPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingGetNextAvailableCapaDayRequest} [schedulingGetNextAvailableCapaDayRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetNextAvailableCapaDayPost: (schedulingGetNextAvailableCapaDayRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/get-next-available-capa-day`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingGetNextAvailableCapaDayRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingGetOFUpdateDateRequest} [schedulingGetOFUpdateDateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetOFUpdateDate: (schedulingGetOFUpdateDateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/get-of-update-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingGetOFUpdateDateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingGetOfsFiltersRequest} [schedulingGetOfsFiltersRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetOfsFiltersPost: (schedulingGetOfsFiltersRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/get-ofs-filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingGetOfsFiltersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetParametersOfDisplayGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/get-parameters-of-display`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingGetQuantiteOFRequest} [schedulingGetQuantiteOFRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetQuantiteOfPost: (schedulingGetQuantiteOFRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/get-quantite-of`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingGetQuantiteOFRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingGetReschedulingLogsRequest} [schedulingGetReschedulingLogsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetReschedulingLogsPost: (schedulingGetReschedulingLogsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/get-rescheduling-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingGetReschedulingLogsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingGetSimulationLastImportDataRequest} [schedulingGetSimulationLastImportDataRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetSimulationLastImportData: (schedulingGetSimulationLastImportDataRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/get-simulation-last-import-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingGetSimulationLastImportDataRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingGetSubOFsRequest} [schedulingGetSubOFsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetSubOfsPost: (schedulingGetSubOFsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/get-sub-ofs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingGetSubOFsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingListOfsGetRequest} [schedulingListOfsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingListOfsPost: (schedulingListOfsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/list-ofs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingListOfsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingMachineCentersPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/machine_centers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingProductionOrdersLeadTimesPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/production_orders_lead_times`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SaveRealtimeSchedulingEventsPostRequest} [saveRealtimeSchedulingEventsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingSaveRealtimeSchedulingEventsPost: (saveRealtimeSchedulingEventsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/save-realtime-scheduling-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveRealtimeSchedulingEventsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SaveSchedulingEventsPostRequest} [saveSchedulingEventsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingSaveSchedulingEventsPost: (saveSchedulingEventsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/save-scheduling-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveSchedulingEventsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingSseProductionOrdersPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/sse_production_orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateCapacityFromSimulationPostRequest} [updateCapacityFromSimulationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingUpdateCapacityFromSimulationPost: (updateCapacityFromSimulationPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/update-capacity-from-simulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateCapacityFromSimulationPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingUpdateConwipTicketsGaugesPostRequest} [schedulingUpdateConwipTicketsGaugesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingUpdateConwipTicketsGaugesPost: (schedulingUpdateConwipTicketsGaugesPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/update-conwip-tickets-gauges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingUpdateConwipTicketsGaugesPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SectorsAutoOrgaGetRequest} [sectorsAutoOrgaGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsAutoOrgaPost: (sectorsAutoOrgaGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/sectors/auto_orga`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sectorsAutoOrgaGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsClientAutoOrgaGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/sectors/client-auto-orga`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SectorsFromTypeWithMoveXGetRequest} [sectorsFromTypeWithMoveXGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsFromTypeWithMovexPost: (sectorsFromTypeWithMoveXGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/sectors/from-type-with-movex`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sectorsFromTypeWithMoveXGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetAllSectorsInClientGroupRequest} [getAllSectorsInClientGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsGetAllSectorsInClientGroup: (getAllSectorsInClientGroupRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/client-groups/get-all-sectors-in-client-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAllSectorsInClientGroupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsCalendarsRequest} [sectorsCalendarsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdCalendarsPost: (secteurId, sectorsCalendarsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'secteurId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdCalendarsPost', 'secteurId', secteurId);
            const localVarPath = `/api/sectors/{secteur_id}/calendars`
                .replace(`{${"secteur_id"}}`, encodeURIComponent(String(secteurId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sectorsCalendarsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdDefaultCapacitiesPost: (secteurId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'secteurId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdDefaultCapacitiesPost', 'secteurId', secteurId);
            const localVarPath = `/api/sectors/{secteur_id}/default-capacities`
                .replace(`{${"secteur_id"}}`, encodeURIComponent(String(secteurId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {string} importId
         * @param {SectorsImportsDelaysGetRequest} [sectorsImportsDelaysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdDelaysImportIdPost: (secteurId, importId, sectorsImportsDelaysGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'secteurId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdDelaysImportIdPost', 'secteurId', secteurId);
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdDelaysImportIdPost', 'importId', importId);
            const localVarPath = `/api/sectors/{secteur_id}/delays/{import_id}`
                .replace(`{${"secteur_id"}}`, encodeURIComponent(String(secteurId)))
                .replace(`{${"import_id"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sectorsImportsDelaysGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsDelaysGetRequest} [sectorsDelaysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdDelaysPost: (secteurId, sectorsDelaysGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'secteurId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdDelaysPost', 'secteurId', secteurId);
            const localVarPath = `/api/sectors/{secteur_id}/delays`
                .replace(`{${"secteur_id"}}`, encodeURIComponent(String(secteurId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sectorsDelaysGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdFormulasGet: (secteurId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'secteurId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdFormulasGet', 'secteurId', secteurId);
            const localVarPath = `/api/sectors/{secteur_id}/formulas`
                .replace(`{${"secteur_id"}}`, encodeURIComponent(String(secteurId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdMercateamAvailableOperatorsGet: (secteurId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'secteurId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdMercateamAvailableOperatorsGet', 'secteurId', secteurId);
            const localVarPath = `/api/sectors/{secteur_id}/mercateam-available-operators`
                .replace(`{${"secteur_id"}}`, encodeURIComponent(String(secteurId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdMsdParametersGet: (secteurId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'secteurId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdMsdParametersGet', 'secteurId', secteurId);
            const localVarPath = `/api/sectors/{secteur_id}/msd-parameters`
                .replace(`{${"secteur_id"}}`, encodeURIComponent(String(secteurId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsOperatorsGetRequest} [sectorsOperatorsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdOperatorsPost: (secteurId, sectorsOperatorsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'secteurId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdOperatorsPost', 'secteurId', secteurId);
            const localVarPath = `/api/sectors/{secteur_id}/operators`
                .replace(`{${"secteur_id"}}`, encodeURIComponent(String(secteurId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sectorsOperatorsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdParametersFieldsGet: (secteurId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'secteurId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdParametersFieldsGet', 'secteurId', secteurId);
            const localVarPath = `/api/sectors/{secteur_id}/parameters/fields`
                .replace(`{${"secteur_id"}}`, encodeURIComponent(String(secteurId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsParametersGetRequest} [sectorsParametersGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdParametersPost: (secteurId, sectorsParametersGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'secteurId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdParametersPost', 'secteurId', secteurId);
            const localVarPath = `/api/sectors/{secteur_id}/parameters`
                .replace(`{${"secteur_id"}}`, encodeURIComponent(String(secteurId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sectorsParametersGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdUnitsGet: (secteurId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'secteurId' is not null or undefined
            assertParamExists('apiSectorsSecteurIdUnitsGet', 'secteurId', secteurId);
            const localVarPath = `/api/sectors/{secteur_id}/units`
                .replace(`{${"secteur_id"}}`, encodeURIComponent(String(secteurId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {LoggingGetRequest} [loggingGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerLogPost: (loggingGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/server-log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(loggingGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} filePath
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShuffledGet: (filePath, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'filePath' is not null or undefined
            assertParamExists('apiShuffledGet', 'filePath', filePath);
            const localVarPath = `/api/shuffled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filePath !== undefined) {
                localVarQueryParameter['filePath'] = filePath;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SimulationsLoadsFullGetRequest} [simulationsLoadsFullGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsAbsoluteLoadsFullPost: (simulationsLoadsFullGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/simulations/absolute/loads/full`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsLoadsFullGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} ofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsAbsoluteOfsOfIdLastDateGet: (ofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ofId' is not null or undefined
            assertParamExists('apiSimulationsAbsoluteOfsOfIdLastDateGet', 'ofId', ofId);
            const localVarPath = `/api/simulations/absolute/ofs/{of_id}/last-date`
                .replace(`{${"of_id"}}`, encodeURIComponent(String(ofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SimulationsCreatePostRequest} [simulationsCreatePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsCreatePost: (simulationsCreatePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/simulations/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsCreatePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SimulationsGanttLoadsGetRequest} [simulationsGanttLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGanttLoadsPost: (simulationsGanttLoadsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/simulations/gantt-loads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsGanttLoadsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetGroupSynthesisAvailableClientIDs: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/client-groups/get-group-synthesis-available-client-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetGroupSynthesisTableDataRequest} [getGroupSynthesisTableDataRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetGroupSynthesisTableData: (getGroupSynthesisTableDataRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/client-groups/get-group-synthesis-table-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getGroupSynthesisTableDataRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SimulationGetQuantitiesRequest} [simulationGetQuantitiesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetLoadQuantitiesPost: (simulationGetQuantitiesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/simulations/get-load-quantities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationGetQuantitiesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetSectorWLoadFormula: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/simulations/get-sector-w-load-formula`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {HasSectorWLoadAndFormulaRequest} [hasSectorWLoadAndFormulaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsHasSectorWLoadAndFormula: (hasSectorWLoadAndFormulaRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/simulations/has-sector-w-load-and-formula`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(hasSectorWLoadAndFormulaRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SimulationsLoadTableGetRequest} [simulationsLoadTableGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsLoadTableSsePost: (simulationsLoadTableGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/simulations/load-table-sse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsLoadTableGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsDailyLoadsGetRequest} [simulationsDailyLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdDailyLoadsPost: (simulationId, simulationsDailyLoadsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdDailyLoadsPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/daily-loads`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsDailyLoadsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsDisabledEventsGetRequest} [simulationsDisabledEventsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdDisabledEventsPost: (simulationId, simulationsDisabledEventsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdDisabledEventsPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/disabled-events`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsDisabledEventsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {SimulationEventFieldsGetRequest} [simulationEventFieldsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdEventFieldsPost: (simulationId, simulationEventFieldsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdEventFieldsPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/event-fields`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationEventFieldsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsEventsInfosGetRequest} [simulationsEventsInfosGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdEventsInfosPost: (simulationId, simulationsEventsInfosGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdEventsInfosPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/events-infos`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsEventsInfosGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsImportsGetRequest} [simulationsImportsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdImportsPost: (simulationId, simulationsImportsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdImportsPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/imports`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsImportsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsLoadGraphGetRequest} [simulationsLoadGraphGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadGraphPost: (simulationId, simulationsLoadGraphGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdLoadGraphPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/load-graph`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsLoadGraphGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsLoadsFullGetRequest} [simulationsLoadsFullGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadsFullPost: (simulationId, simulationsLoadsFullGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdLoadsFullPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/loads/full`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsLoadsFullGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsLoadsGetRequest} [simulationsLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadsPost: (simulationId, simulationsLoadsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdLoadsPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/loads`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsLoadsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsRawLoadsGetRequest} [simulationsRawLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadsRawPost: (simulationId, simulationsRawLoadsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdLoadsRawPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/loads/raw`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationsRawLoadsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdOfsLastDoneDatePost: (simulationId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdOfsLastDoneDatePost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/ofs/last-done-date`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdOfsPost: (simulationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdOfsPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/ofs`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdOpsPost: (simulationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdOpsPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/ops`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {SimulationSectorsLoadsGetRequest} [simulationSectorsLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdSectorsLoadsPost: (simulationId, simulationSectorsLoadsGetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('apiSimulationsSimulationIdSectorsLoadsPost', 'simulationId', simulationId);
            const localVarPath = `/api/simulations/{simulation_id}/sectors-loads`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationSectorsLoadsGetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SimulationUpdateFromSchedulingRequest} [simulationUpdateFromSchedulingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsUpdateLoadFromSchedulingPost: (simulationUpdateFromSchedulingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/simulations/update-load-from-scheduling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(simulationUpdateFromSchedulingRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSpecificSaintGobainSullyLastUpdatesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/specific/saint-gobain-sully/last-updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdjustProdObjectiveRequest} [adjustProdObjectiveRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksAdjustProdObjectivePost: (adjustProdObjectiveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/stocks/adjust-prod-objective`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adjustProdObjectiveRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {StocksGetDemandRequest} [stocksGetDemandRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksGetDemandPost: (stocksGetDemandRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/stocks/get-demand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(stocksGetDemandRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {StocksGetOverloadedSectorsByArticlesRequest} [stocksGetOverloadedSectorsByArticlesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksGetOverloadedSectorsByArticlesPost: (stocksGetOverloadedSectorsByArticlesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/stocks/get_overloaded_sectors_by_articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(stocksGetOverloadedSectorsByArticlesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {StocksSetDemandRequest} [stocksSetDemandRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksSetDemandPost: (stocksSetDemandRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/stocks/set-demand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(stocksSetDemandRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTasksPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersCheckLastLoginPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/users/check-last-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersFlushCacheGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/users/flush-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUpdateFromFirebasePost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/users/update-from-firebase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ValidatePasswordExpirationRouteRequest} [validatePasswordExpirationRouteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authValidatePasswordExpirationPost: (validatePasswordExpirationRouteRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/auth/validate-password-expiration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(validatePasswordExpirationRouteRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {BalanceLoadToCapacityRequest} [balanceLoadToCapacityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceLoadToCapacity: (balanceLoadToCapacityRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/stocks/balance-load-to-capacity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(balanceLoadToCapacityRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bigqueryGetPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/bigquery/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ProdObjectiveTransferRequest} [prodObjectiveTransferRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProdObjectiveTransfer: (prodObjectiveTransferRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/stocks/prod-objective-transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(prodObjectiveTransferRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DailyCapacityAndTotalCapacityByDateRequest} [dailyCapacityAndTotalCapacityByDateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyCapacityAndTotalCapacityByDate: (dailyCapacityAndTotalCapacityByDateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/capacities/daily-capacity-and-total-capacity-by-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dailyCapacityAndTotalCapacityByDateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} opId
         * @param {string} simulationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestLoadEventsRowsByOpId: (opId, simulationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'opId' is not null or undefined
            assertParamExists('getLatestLoadEventsRowsByOpId', 'opId', opId);
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getLatestLoadEventsRowsByOpId', 'simulationId', simulationId);
            const localVarPath = `/api/scheduling/get-latest-load-events-rows-by-op-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (opId !== undefined) {
                localVarQueryParameter['op_id'] = opId;
            }
            if (simulationId !== undefined) {
                localVarQueryParameter['simulation_id'] = simulationId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {LoadRateAndRemainingCapacityRequest} [loadRateAndRemainingCapacityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadRateAndRemainingCapacity: (loadRateAndRemainingCapacityRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/capacities/load-rate-and-remaining-capacity-by-period`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(loadRateAndRemainingCapacityRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {SchedulingGetAnalyticsRequest} [schedulingGetAnalyticsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingAnalytics: (simulationId, schedulingGetAnalyticsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getSchedulingAnalytics', 'simulationId', simulationId);
            const localVarPath = `/api/scheduling/{simulation_id}/get-analytics`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingGetAnalyticsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingComponentsGetComponentAnalyticsRequest} [schedulingComponentsGetComponentAnalyticsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentAnalytics: (schedulingComponentsGetComponentAnalyticsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling-components/get-component-analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingComponentsGetComponentAnalyticsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingComponentsGetComponentDetailsRequest} [schedulingComponentsGetComponentDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentDetails: (schedulingComponentsGetComponentDetailsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling-components/get-component-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingComponentsGetComponentDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingComponentsGetComponentInitialStockRequest} [schedulingComponentsGetComponentInitialStockRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentInitialStock: (schedulingComponentsGetComponentInitialStockRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling-components/get-component-initial-stock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingComponentsGetComponentInitialStockRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingComponentsGetComponentsCurrentStocksRequest} [schedulingComponentsGetComponentsCurrentStocksRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentsCurrentStocks: (schedulingComponentsGetComponentsCurrentStocksRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling-components/get-components-current-stocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingComponentsGetComponentsCurrentStocksRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SchedulingComponentsGetSidebarComponentsDetailsRequest} [schedulingComponentsGetSidebarComponentsDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsSidebarComponentsDetails: (schedulingComponentsGetSidebarComponentsDetailsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling-components/get-sidebar-components-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schedulingComponentsGetSidebarComponentsDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} simulationId
         * @param {string} ofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationsOfsParams: (simulationId, ofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getSimulationsOfsParams', 'simulationId', simulationId);
            // verify required parameter 'ofId' is not null or undefined
            assertParamExists('getSimulationsOfsParams', 'ofId', ofId);
            const localVarPath = `/api/simulations/{simulation_id}/ofs/{of_id}/last-date`
                .replace(`{${"simulation_id"}}`, encodeURIComponent(String(simulationId)))
                .replace(`{${"of_id"}}`, encodeURIComponent(String(ofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {StocksGetDemandByArticlesRequest} [stocksGetDemandByArticlesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksDemandByArticles: (stocksGetDemandByArticlesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/stocks/get_demand_by_articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(stocksGetDemandByArticlesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {StocksGetObjectiveByArticlesRequest} [stocksGetObjectiveByArticlesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksObjectiveByArticles: (stocksGetObjectiveByArticlesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/stocks/get-objective-by-articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(stocksGetObjectiveByArticlesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksSectorsIdsFromGammes: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/stocks/get-sectors-ids-from-gammes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {StocksGetStocksTableRequest} [stocksGetStocksTableRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksTable: (stocksGetStocksTableRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/stocks/get-stocks-table`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(stocksGetStocksTableRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFilePost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/import/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowsPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/import/rows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importSignedUrlGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/import/signed_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importUpdateDataB2bPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/import/update_data_b2b`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importUpdateDataPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/import/update_data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyOnOplitDateParametersUpdate: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/oplit-date/notify-on-client-parameters-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pgParserPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/pg/parser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOPsUpdatesToSGS: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/scheduling/send-ops-updates-to-sgs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {MicrosoftRoleSyncRouteRequest} [microsoftRoleSyncRouteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMicrosoftRoles: (microsoftRoleSyncRouteRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/auth/msft/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(microsoftRoleSyncRouteRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SyncOIDCUserRouteRequest} [syncOIDCUserRouteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOIDCUser: (syncOIDCUserRouteRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/auth/oidc/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(syncOIDCUserRouteRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {any} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminHackyDevFnsPost(body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAdminHackyDevFnsPost(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAdminHackyDevFnsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminInfraCostsByClientGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAdminInfraCostsByClientGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAdminInfraCostsByClientGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {GetCrossingTimesByArticleRequest} [getCrossingTimesByArticleRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsCrossingTimesByArticlePost(getCrossingTimesByArticleRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAnalyticsCrossingTimesByArticlePost(getCrossingTimesByArticleRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAnalyticsCrossingTimesByArticlePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsCrossingTimesPost(body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAnalyticsCrossingTimesPost(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAnalyticsCrossingTimesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AnalyticsOfsEndTimeRequest} [analyticsOfsEndTimeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEndTimePost(analyticsOfsEndTimeRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAnalyticsEndTimePost(analyticsOfsEndTimeRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAnalyticsEndTimePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AnalyticsFiltersRequest} [analyticsFiltersRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsFiltersPost(analyticsFiltersRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAnalyticsFiltersPost(analyticsFiltersRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAnalyticsFiltersPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {GetOPsByOFRequest} [getOPsByOFRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsGetOpsByOfPost(getOPsByOFRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAnalyticsGetOpsByOfPost(getOPsByOFRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAnalyticsGetOpsByOfPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AnalyticsOFRequest} [analyticsOFRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsOfsPost(analyticsOFRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAnalyticsOfsPost(analyticsOFRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAnalyticsOfsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AnalyticsProgressRequest} [analyticsProgressRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsProgressPost(analyticsProgressRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAnalyticsProgressPost(analyticsProgressRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAnalyticsProgressPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AnalyticsStagnationRequest} [analyticsStagnationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsStagnationPost(analyticsStagnationRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAnalyticsStagnationPost(analyticsStagnationRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAnalyticsStagnationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AnalyticsOfsStartedOnTimeRequest} [analyticsOfsStartedOnTimeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsStartedOnTimePost(analyticsOfsStartedOnTimeRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAnalyticsStartedOnTimePost(analyticsOfsStartedOnTimeRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAnalyticsStartedOnTimePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AnalyticsWIPRequest} [analyticsWIPRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsWipPost(analyticsWIPRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiAnalyticsWipPost(analyticsWIPRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiAnalyticsWipPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {RecoverImportPostRequest} [recoverImportPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArchivesRecoverImportPost(recoverImportPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiArchivesRecoverImportPost(recoverImportPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiArchivesRecoverImportPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {RecoverSimulationPostRequest} [recoverSimulationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArchivesRecoverSimulationPost(recoverSimulationPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiArchivesRecoverSimulationPost(recoverSimulationPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiArchivesRecoverSimulationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ArticlesGetRequest} [articlesGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlePost(articlesGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiArticlePost(articlesGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiArticlePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ArticlesGetRequest} [articlesGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticleTargetStockPost(articlesGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiArticleTargetStockPost(articlesGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiArticleTargetStockPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {GetWorkdaysPostRequest} [getWorkdaysPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalendarGetWorkdaysPost(getWorkdaysPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCalendarGetWorkdaysPost(getWorkdaysPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCalendarGetWorkdaysPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SaveCalendarRequest} [saveCalendarRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalendarSaveCalendarPost(saveCalendarRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCalendarSaveCalendarPost(saveCalendarRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCalendarSaveCalendarPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalendarTestPost(body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCalendarTestPost(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCalendarTestPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CalculateCapaRequest} [calculateCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesCalculateCapaPost(calculateCapaRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCapacitiesCalculateCapaPost(calculateCapaRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCapacitiesCalculateCapaPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DailyCapacityRequest} [dailyCapacityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesDailyPost(dailyCapacityRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCapacitiesDailyPost(dailyCapacityRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCapacitiesDailyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DailyTotalCapaRequest} [dailyTotalCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesDailyTotalCapaPost(dailyTotalCapaRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCapacitiesDailyTotalCapaPost(dailyTotalCapaRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCapacitiesDailyTotalCapaPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {FullTimeNeedRequest} [fullTimeNeedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesFullTimeNeedPost(fullTimeNeedRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCapacitiesFullTimeNeedPost(fullTimeNeedRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCapacitiesFullTimeNeedPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {NeededOrgaRequest} [neededOrgaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesNeededOrgaPost(neededOrgaRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCapacitiesNeededOrgaPost(neededOrgaRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCapacitiesNeededOrgaPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {OverloadedSectorsRequest} [overloadedSectorsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesOverloadedSectorsPost(overloadedSectorsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCapacitiesOverloadedSectorsPost(overloadedSectorsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCapacitiesOverloadedSectorsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {TotalCapaRequest} [totalCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesTotalCapaPost(totalCapaRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCapacitiesTotalCapaPost(totalCapaRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCapacitiesTotalCapaPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {TotalRemainingCapaRequest} [totalRemainingCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesTotalRemainingCapaPost(totalRemainingCapaRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCapacitiesTotalRemainingCapaPost(totalRemainingCapaRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCapacitiesTotalRemainingCapaPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ClientsCreateRequest} [clientsCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsPost(clientsCreateRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiClientsPost(clientsCreateRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiClientsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CrispHasNewProductReleaseRequest} [crispHasNewProductReleaseRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsCrispHasNewProductReleasePost(crispHasNewProductReleaseRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsCrispHasNewProductReleasePost(crispHasNewProductReleaseRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsCrispHasNewProductReleasePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsCrispWebhooksPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsCrispWebhooksPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsCrispWebhooksPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CapaBySectorRequest} [capaBySectorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsExternalCapaBySectorPost(capaBySectorRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsExternalCapaBySectorPost(capaBySectorRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsExternalCapaBySectorPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsExternalSectorsGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsExternalSectorsGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsExternalSectorsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AddCyclePostRequest} [addCyclePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearAddCyclePost(addCyclePostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsLinearAddCyclePost(addCyclePostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsLinearAddCyclePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearListCyclesPost(body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsLinearListCyclesPost(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsLinearListCyclesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CycleIdRequest} [cycleIdRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearLoadCycleDataPost(cycleIdRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsLinearLoadCycleDataPost(cycleIdRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsLinearLoadCycleDataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SupportDateRangeRequest} [supportDateRangeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearLoadSupportDataPost(supportDateRangeRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsLinearLoadSupportDataPost(supportDateRangeRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsLinearLoadSupportDataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SaveTeamDataPointRequest} [saveTeamDataPointRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearSaveTeamDataPointPost(saveTeamDataPointRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsLinearSaveTeamDataPointPost(saveTeamDataPointRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsLinearSaveTeamDataPointPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {LinearTechKPIsPostRequest} [linearTechKPIsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearTechKpisPost(linearTechKPIsPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsLinearTechKpisPost(linearTechKPIsPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsLinearTechKpisPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearTimeCalculatorPost(body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsLinearTimeCalculatorPost(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsLinearTimeCalculatorPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearUpdateLabelsPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsLinearUpdateLabelsPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsLinearUpdateLabelsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearWebhooksPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsLinearWebhooksPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsLinearWebhooksPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {M3ExtractionRequest} [m3ExtractionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsM3ExtractDataPost(m3ExtractionRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiConnectorsM3ExtractDataPost(m3ExtractionRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiConnectorsM3ExtractDataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetCustomersDetailsGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCustomerInterfaceGetCustomersDetailsGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCustomerInterfaceGetCustomersDetailsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetFiltersGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCustomerInterfaceGetFiltersGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCustomerInterfaceGetFiltersGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CustomerInterfaceGetOfsDetailsRequest} [customerInterfaceGetOfsDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetOfsDetailsPost(customerInterfaceGetOfsDetailsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCustomerInterfaceGetOfsDetailsPost(customerInterfaceGetOfsDetailsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCustomerInterfaceGetOfsDetailsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetProviderIdsGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCustomerInterfaceGetProviderIdsGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCustomerInterfaceGetProviderIdsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CustomerInterfaceListOfsGetRequest} [customerInterfaceListOfsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceListOfsPost(customerInterfaceListOfsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiCustomerInterfaceListOfsPost(customerInterfaceListOfsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiCustomerInterfaceListOfsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DailyDelaysGetRequest} [dailyDelaysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDailyDelaysPost(dailyDelaysGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiDailyDelaysPost(dailyDelaysGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiDailyDelaysPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DelaysBySectorGetRequest} [delaysBySectorGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDelaysPost(delaysBySectorGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiDelaysPost(delaysBySectorGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiDelaysPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {EventsGetRequest} [eventsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsDetailsPost(eventsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsDetailsPost(eventsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiEventsDetailsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {EventsFieldsGetRequest} [eventsFieldsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsFieldsPost(eventsFieldsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsFieldsPost(eventsFieldsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiEventsFieldsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {EventsGetSimpleEventsPostRequest} [eventsGetSimpleEventsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsGetSimpleEventsPost(eventsGetSimpleEventsPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsGetSimpleEventsPost(eventsGetSimpleEventsPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiEventsGetSimpleEventsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {EventsMigratePostRequest} [eventsMigratePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsMigratePost(eventsMigratePostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsMigratePost(eventsMigratePostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiEventsMigratePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsOnChangePost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsOnChangePost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiEventsOnChangePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsOnChangeSsePost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsOnChangeSsePost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiEventsOnChangeSsePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {any | Array<any>} [anyArrayany]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsPushPost(anyArrayany, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsPushPost(anyArrayany, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiEventsPushPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqCheckConnectionGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiFabriqCheckConnectionGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiFabriqCheckConnectionGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqCreateTicketTicketIdPost(ticketId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiFabriqCreateTicketTicketIdPost(ticketId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiFabriqCreateTicketTicketIdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqDeleteTicketTicketIdPost(ticketId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiFabriqDeleteTicketTicketIdPost(ticketId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiFabriqDeleteTicketTicketIdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqGetTicketTicketIdGet(ticketId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiFabriqGetTicketTicketIdGet(ticketId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiFabriqGetTicketTicketIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqGetUsersGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiFabriqGetUsersGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiFabriqGetUsersGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {GammesGetRequest} [gammesGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGammesPost(gammesGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiGammesPost(gammesGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiGammesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {GetDownloadURLRequest} [getDownloadURLRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetDownloadUrlPost(getDownloadURLRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiGetDownloadUrlPost(getDownloadURLRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiGetDownloadUrlPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ImportsDetailedInitialStocksRequest} [importsDetailedInitialStocksRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsDetailedInitialStocksPost(importsDetailedInitialStocksRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsDetailedInitialStocksPost(importsDetailedInitialStocksRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsDetailedInitialStocksPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ImportErrorLogsRequestBody} [importErrorLogsRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsErrorLogsPost(importErrorLogsRequestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsErrorLogsPost(importErrorLogsRequestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsErrorLogsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ImportsFieldsKeysGetRequest} [importsFieldsKeysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsFieldsKeysPost(importsFieldsKeysGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsFieldsKeysPost(importsFieldsKeysGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsFieldsKeysPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ImportsGenerateFileRequest} [importsGenerateFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsGenerateImportFilePost(importsGenerateFileRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsGenerateImportFilePost(importsGenerateFileRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsGenerateImportFilePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {GetImportUnitsRequest} [getImportUnitsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsGetImportUnitsPost(getImportUnitsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsGetImportUnitsPost(getImportUnitsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsGetImportUnitsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} importId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdArticlesRefsPost(importId, body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsImportIdArticlesRefsPost(importId, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsImportIdArticlesRefsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} importId
         * @param {ImportsDailyRawLoadsGetRequest} [importsDailyRawLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdDailyRawLoadsPost(importId, importsDailyRawLoadsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsImportIdDailyRawLoadsPost(importId, importsDailyRawLoadsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsImportIdDailyRawLoadsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} importId
         * @param {ImportsSpecificLoadsGetRequest} [importsSpecificLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdLoadsPost(importId, importsSpecificLoadsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsImportIdLoadsPost(importId, importsSpecificLoadsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsImportIdLoadsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} importId
         * @param {string} ofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdOfsOfIdLastDateGet(importId, ofId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsImportIdOfsOfIdLastDateGet(importId, ofId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsImportIdOfsOfIdLastDateGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ImportLogsRequestBody} [importLogsRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportLogsPost(importLogsRequestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsImportLogsPost(importLogsRequestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsImportLogsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ImportsInitialStocksRequest} [importsInitialStocksRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsInitialStocksPost(importsInitialStocksRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsInitialStocksPost(importsInitialStocksRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsInitialStocksPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ImportsLastRequest} [importsLastRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsLastPost(importsLastRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsLastPost(importsLastRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsLastPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ImportsLateRequest} [importsLateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsLatePost(importsLateRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsLatePost(importsLateRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsLatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ImportsLoadsGetRequest} [importsLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsLoadsPost(importsLoadsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsLoadsPost(importsLoadsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsLoadsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ImportsSkippedRequest} [importsSkippedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsSkippedPost(importsSkippedRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiImportsSkippedPost(importsSkippedRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiImportsSkippedPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {LaunchPgMigrateRequest} [launchPgMigrateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLaunchPgMigratePost(launchPgMigrateRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiLaunchPgMigratePost(launchPgMigrateRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiLaunchPgMigratePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetAbsencesGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiMercateamGetAbsencesGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiMercateamGetAbsencesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetEmployeesListGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiMercateamGetEmployeesListGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiMercateamGetEmployeesListGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetPlanningsGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiMercateamGetPlanningsGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiMercateamGetPlanningsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetSectorsPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiMercateamGetSectorsPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiMercateamGetSectorsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetStatusGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiMercateamGetStatusGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiMercateamGetStatusGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamSavePlanningsPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiMercateamSavePlanningsPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiMercateamSavePlanningsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamSaveUnexpectedEventsPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiMercateamSaveUnexpectedEventsPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiMercateamSaveUnexpectedEventsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DbHelperProxyPostRequest} [dbHelperProxyPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationDbhelperProxyPost(dbHelperProxyPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiMigrationDbhelperProxyPost(dbHelperProxyPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiMigrationDbhelperProxyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {MigrateToTargetPostRequest} [migrateToTargetPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationMigrateToTargetPost(migrateToTargetPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiMigrationMigrateToTargetPost(migrateToTargetPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiMigrationMigrateToTargetPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PGProxyPostRequest} [pGProxyPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationPgProxyPost(pGProxyPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiMigrationPgProxyPost(pGProxyPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiMigrationPgProxyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNomenclaturesGetAllGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiNomenclaturesGetAllGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiNomenclaturesGetAllGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {NomenclaturesPostRequestUpdate} [nomenclaturesPostRequestUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNomenclaturesUpdatePost(nomenclaturesPostRequestUpdate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiNomenclaturesUpdatePost(nomenclaturesPostRequestUpdate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiNomenclaturesUpdatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {OplitCopilotTriggerCopilotReschedulingPostRequest} [oplitCopilotTriggerCopilotReschedulingPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitCopilotTriggerCopilotRescheduling(oplitCopilotTriggerCopilotReschedulingPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiOplitCopilotTriggerCopilotRescheduling(oplitCopilotTriggerCopilotReschedulingPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiOplitCopilotTriggerCopilotRescheduling']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {OplitDateGetCsvWithOplitDatePostRequest} [oplitDateGetCsvWithOplitDatePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGenerateCSVDoneOFsHistory(oplitDateGetCsvWithOplitDatePostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiOplitDateGenerateCSVDoneOFsHistory(oplitDateGetCsvWithOplitDatePostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiOplitDateGenerateCSVDoneOFsHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {OplitDateGetCsvWithOplitDatePostRequest} [oplitDateGetCsvWithOplitDatePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGenerateCSVOngoingOFsEstimations(oplitDateGetCsvWithOplitDatePostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiOplitDateGenerateCSVOngoingOFsEstimations(oplitDateGetCsvWithOplitDatePostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiOplitDateGenerateCSVOngoingOFsEstimations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetClientFeatures(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiOplitDateGetClientFeatures(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiOplitDateGetClientFeatures']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetClientOFs(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiOplitDateGetClientOFs(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiOplitDateGetClientOFs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetClientTeamSettings(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiOplitDateGetClientTeamSettings(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiOplitDateGetClientTeamSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {OplitDateGetCsvWithOfHistoryPostRequest} [oplitDateGetCsvWithOfHistoryPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetCsvWithOfHistory(oplitDateGetCsvWithOfHistoryPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiOplitDateGetCsvWithOfHistory(oplitDateGetCsvWithOfHistoryPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiOplitDateGetCsvWithOfHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetImpactedScopes(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiOplitDateGetImpactedScopes(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiOplitDateGetImpactedScopes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetLastUpdate(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiOplitDateGetLastUpdate(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiOplitDateGetLastUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {OplitDateSaveClientFeaturesPostRequest} [oplitDateSaveClientFeaturesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateSaveClientFeatures(oplitDateSaveClientFeaturesPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiOplitDateSaveClientFeatures(oplitDateSaveClientFeaturesPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiOplitDateSaveClientFeatures']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {OplitDateSaveOplitDateTeamSettingsPostRequest} [oplitDateSaveOplitDateTeamSettingsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateSaveOplitDateTeamSettings(oplitDateSaveOplitDateTeamSettingsPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiOplitDateSaveOplitDateTeamSettings(oplitDateSaveOplitDateTeamSettingsPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiOplitDateSaveOplitDateTeamSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PdpLoadGetInitialLoadsRequest} [pdpLoadGetInitialLoadsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadGetInitialLoadsPost(pdpLoadGetInitialLoadsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPdpLoadGetInitialLoadsPost(pdpLoadGetInitialLoadsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPdpLoadGetInitialLoadsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PdpLoadGetLoadEventsRequest} [pdpLoadGetLoadEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadGetLoadEventsPost(pdpLoadGetLoadEventsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPdpLoadGetLoadEventsPost(pdpLoadGetLoadEventsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPdpLoadGetLoadEventsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PdpLoadGetSectorChargePostRequest} [pdpLoadGetSectorChargePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadGetSectorChargePost(pdpLoadGetSectorChargePostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPdpLoadGetSectorChargePost(pdpLoadGetSectorChargePostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPdpLoadGetSectorChargePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadHasSectorChargeFormulaGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPdpLoadHasSectorChargeFormulaGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPdpLoadHasSectorChargeFormulaGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PdpLoadSaveLoadEventRequest} [pdpLoadSaveLoadEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadSaveLoadEventPost(pdpLoadSaveLoadEventRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPdpLoadSaveLoadEventPost(pdpLoadSaveLoadEventRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPdpLoadSaveLoadEventPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PdpLoadUpdateLoadEventRequest} [pdpLoadUpdateLoadEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadUpdateLoadEventPost(pdpLoadUpdateLoadEventRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPdpLoadUpdateLoadEventPost(pdpLoadUpdateLoadEventRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPdpLoadUpdateLoadEventPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PgTriggersPostRequest} [pgTriggersPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPgTriggersPost(pgTriggersPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPgTriggersPost(pgTriggersPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPgTriggersPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AbsencesByOperatorRequest} [absencesByOperatorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningAbsencesByOperatorPost(absencesByOperatorRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPlanningAbsencesByOperatorPost(absencesByOperatorRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPlanningAbsencesByOperatorPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DailyPlanningRequest} [dailyPlanningRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningDailyPlanningPost(dailyPlanningRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPlanningDailyPlanningPost(dailyPlanningRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPlanningDailyPlanningPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {IsGoulotRequest} [isGoulotRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningIsGoulotPost(isGoulotRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPlanningIsGoulotPost(isGoulotRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPlanningIsGoulotPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {MachinesByOperatorRequest} [machinesByOperatorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningMachinesByOperatorPost(machinesByOperatorRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPlanningMachinesByOperatorPost(machinesByOperatorRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPlanningMachinesByOperatorPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {MachinesBySectorRequest} [machinesBySectorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningMachinesBySectorPost(machinesBySectorRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPlanningMachinesBySectorPost(machinesBySectorRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPlanningMachinesBySectorPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CustomMSDFieldValueRequest} [customMSDFieldValueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningMsdFieldValuePost(customMSDFieldValueRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPlanningMsdFieldValuePost(customMSDFieldValueRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPlanningMsdFieldValuePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {OperatorsByMachineRequest} [operatorsByMachineRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningOperatorsByMachinePost(operatorsByMachineRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPlanningOperatorsByMachinePost(operatorsByMachineRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPlanningOperatorsByMachinePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {OperatorsBySectorRequest} [operatorsBySectorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningOperatorsBySectorPost(operatorsBySectorRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPlanningOperatorsBySectorPost(operatorsBySectorRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPlanningOperatorsBySectorPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {PeriodesOrgaRequest} [periodesOrgaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningPeriodesOrgaPost(periodesOrgaRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPlanningPeriodesOrgaPost(periodesOrgaRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPlanningPeriodesOrgaPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SaveStandardPlanningRequest} [saveStandardPlanningRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningSaveStandardPlanningPost(saveStandardPlanningRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPlanningSaveStandardPlanningPost(saveStandardPlanningRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPlanningSaveStandardPlanningPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ProductionsAllGetRequest} [productionsAllGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionsAllPost(productionsAllGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiProductionsAllPost(productionsAllGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiProductionsAllPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ProductionsLastProdUpdateGetRequest} [productionsLastProdUpdateGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionsLastProdUpdatePost(productionsLastProdUpdateGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiProductionsLastProdUpdatePost(productionsLastProdUpdateGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiProductionsLastProdUpdatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPubsubPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiPubsubPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiPubsubPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingAiPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingAiPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingAiPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingCancelLastSchedulingAIRequest} [schedulingCancelLastSchedulingAIRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingCancelLastReschedulingAiPost(schedulingCancelLastSchedulingAIRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingCancelLastReschedulingAiPost(schedulingCancelLastSchedulingAIRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingCancelLastReschedulingAiPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingGetConwipTicketsGaugesPostRequest} [schedulingGetConwipTicketsGaugesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetConwipTicketsGaugesPost(schedulingGetConwipTicketsGaugesPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingGetConwipTicketsGaugesPost(schedulingGetConwipTicketsGaugesPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingGetConwipTicketsGaugesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingGetNextAvailableCapaDayRequest} [schedulingGetNextAvailableCapaDayRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetNextAvailableCapaDayPost(schedulingGetNextAvailableCapaDayRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingGetNextAvailableCapaDayPost(schedulingGetNextAvailableCapaDayRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingGetNextAvailableCapaDayPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingGetOFUpdateDateRequest} [schedulingGetOFUpdateDateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetOFUpdateDate(schedulingGetOFUpdateDateRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingGetOFUpdateDate(schedulingGetOFUpdateDateRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingGetOFUpdateDate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingGetOfsFiltersRequest} [schedulingGetOfsFiltersRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetOfsFiltersPost(schedulingGetOfsFiltersRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingGetOfsFiltersPost(schedulingGetOfsFiltersRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingGetOfsFiltersPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetParametersOfDisplayGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingGetParametersOfDisplayGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingGetParametersOfDisplayGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingGetQuantiteOFRequest} [schedulingGetQuantiteOFRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetQuantiteOfPost(schedulingGetQuantiteOFRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingGetQuantiteOfPost(schedulingGetQuantiteOFRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingGetQuantiteOfPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingGetReschedulingLogsRequest} [schedulingGetReschedulingLogsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetReschedulingLogsPost(schedulingGetReschedulingLogsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingGetReschedulingLogsPost(schedulingGetReschedulingLogsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingGetReschedulingLogsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingGetSimulationLastImportDataRequest} [schedulingGetSimulationLastImportDataRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetSimulationLastImportData(schedulingGetSimulationLastImportDataRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingGetSimulationLastImportData(schedulingGetSimulationLastImportDataRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingGetSimulationLastImportData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingGetSubOFsRequest} [schedulingGetSubOFsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetSubOfsPost(schedulingGetSubOFsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingGetSubOfsPost(schedulingGetSubOFsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingGetSubOfsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingListOfsGetRequest} [schedulingListOfsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingListOfsPost(schedulingListOfsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingListOfsPost(schedulingListOfsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingListOfsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingMachineCentersPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingMachineCentersPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingMachineCentersPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingProductionOrdersLeadTimesPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingProductionOrdersLeadTimesPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingProductionOrdersLeadTimesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SaveRealtimeSchedulingEventsPostRequest} [saveRealtimeSchedulingEventsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingSaveRealtimeSchedulingEventsPost(saveRealtimeSchedulingEventsPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingSaveRealtimeSchedulingEventsPost(saveRealtimeSchedulingEventsPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingSaveRealtimeSchedulingEventsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SaveSchedulingEventsPostRequest} [saveSchedulingEventsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingSaveSchedulingEventsPost(saveSchedulingEventsPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingSaveSchedulingEventsPost(saveSchedulingEventsPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingSaveSchedulingEventsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingSseProductionOrdersPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingSseProductionOrdersPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingSseProductionOrdersPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {UpdateCapacityFromSimulationPostRequest} [updateCapacityFromSimulationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingUpdateCapacityFromSimulationPost(updateCapacityFromSimulationPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingUpdateCapacityFromSimulationPost(updateCapacityFromSimulationPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingUpdateCapacityFromSimulationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingUpdateConwipTicketsGaugesPostRequest} [schedulingUpdateConwipTicketsGaugesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingUpdateConwipTicketsGaugesPost(schedulingUpdateConwipTicketsGaugesPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSchedulingUpdateConwipTicketsGaugesPost(schedulingUpdateConwipTicketsGaugesPostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSchedulingUpdateConwipTicketsGaugesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SectorsAutoOrgaGetRequest} [sectorsAutoOrgaGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsAutoOrgaPost(sectorsAutoOrgaGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsAutoOrgaPost(sectorsAutoOrgaGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsAutoOrgaPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsClientAutoOrgaGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsClientAutoOrgaGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsClientAutoOrgaGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SectorsFromTypeWithMoveXGetRequest} [sectorsFromTypeWithMoveXGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsFromTypeWithMovexPost(sectorsFromTypeWithMoveXGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsFromTypeWithMovexPost(sectorsFromTypeWithMoveXGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsFromTypeWithMovexPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {GetAllSectorsInClientGroupRequest} [getAllSectorsInClientGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsGetAllSectorsInClientGroup(getAllSectorsInClientGroupRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsGetAllSectorsInClientGroup(getAllSectorsInClientGroupRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsGetAllSectorsInClientGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsCalendarsRequest} [sectorsCalendarsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdCalendarsPost(secteurId, sectorsCalendarsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsSecteurIdCalendarsPost(secteurId, sectorsCalendarsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsSecteurIdCalendarsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdDefaultCapacitiesPost(secteurId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsSecteurIdDefaultCapacitiesPost(secteurId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsSecteurIdDefaultCapacitiesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {string} importId
         * @param {SectorsImportsDelaysGetRequest} [sectorsImportsDelaysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdDelaysImportIdPost(secteurId, importId, sectorsImportsDelaysGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsSecteurIdDelaysImportIdPost(secteurId, importId, sectorsImportsDelaysGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsSecteurIdDelaysImportIdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsDelaysGetRequest} [sectorsDelaysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdDelaysPost(secteurId, sectorsDelaysGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsSecteurIdDelaysPost(secteurId, sectorsDelaysGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsSecteurIdDelaysPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdFormulasGet(secteurId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsSecteurIdFormulasGet(secteurId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsSecteurIdFormulasGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdMercateamAvailableOperatorsGet(secteurId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsSecteurIdMercateamAvailableOperatorsGet(secteurId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsSecteurIdMercateamAvailableOperatorsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdMsdParametersGet(secteurId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsSecteurIdMsdParametersGet(secteurId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsSecteurIdMsdParametersGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsOperatorsGetRequest} [sectorsOperatorsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdOperatorsPost(secteurId, sectorsOperatorsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsSecteurIdOperatorsPost(secteurId, sectorsOperatorsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsSecteurIdOperatorsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdParametersFieldsGet(secteurId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsSecteurIdParametersFieldsGet(secteurId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsSecteurIdParametersFieldsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsParametersGetRequest} [sectorsParametersGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdParametersPost(secteurId, sectorsParametersGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsSecteurIdParametersPost(secteurId, sectorsParametersGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsSecteurIdParametersPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdUnitsGet(secteurId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSectorsSecteurIdUnitsGet(secteurId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSectorsSecteurIdUnitsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {LoggingGetRequest} [loggingGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerLogPost(loggingGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiServerLogPost(loggingGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiServerLogPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} filePath
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShuffledGet(filePath, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiShuffledGet(filePath, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiShuffledGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SimulationsLoadsFullGetRequest} [simulationsLoadsFullGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsAbsoluteLoadsFullPost(simulationsLoadsFullGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsAbsoluteLoadsFullPost(simulationsLoadsFullGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsAbsoluteLoadsFullPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} ofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsAbsoluteOfsOfIdLastDateGet(ofId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsAbsoluteOfsOfIdLastDateGet(ofId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsAbsoluteOfsOfIdLastDateGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SimulationsCreatePostRequest} [simulationsCreatePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsCreatePost(simulationsCreatePostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsCreatePost(simulationsCreatePostRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsCreatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SimulationsGanttLoadsGetRequest} [simulationsGanttLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGanttLoadsPost(simulationsGanttLoadsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsGanttLoadsPost(simulationsGanttLoadsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsGanttLoadsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetGroupSynthesisAvailableClientIDs(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsGetGroupSynthesisAvailableClientIDs(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsGetGroupSynthesisAvailableClientIDs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {GetGroupSynthesisTableDataRequest} [getGroupSynthesisTableDataRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetGroupSynthesisTableData(getGroupSynthesisTableDataRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsGetGroupSynthesisTableData(getGroupSynthesisTableDataRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsGetGroupSynthesisTableData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SimulationGetQuantitiesRequest} [simulationGetQuantitiesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetLoadQuantitiesPost(simulationGetQuantitiesRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsGetLoadQuantitiesPost(simulationGetQuantitiesRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsGetLoadQuantitiesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetSectorWLoadFormula(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsGetSectorWLoadFormula(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsGetSectorWLoadFormula']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {HasSectorWLoadAndFormulaRequest} [hasSectorWLoadAndFormulaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsHasSectorWLoadAndFormula(hasSectorWLoadAndFormulaRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsHasSectorWLoadAndFormula(hasSectorWLoadAndFormulaRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsHasSectorWLoadAndFormula']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SimulationsLoadTableGetRequest} [simulationsLoadTableGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsLoadTableSsePost(simulationsLoadTableGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsLoadTableSsePost(simulationsLoadTableGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsLoadTableSsePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsDailyLoadsGetRequest} [simulationsDailyLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdDailyLoadsPost(simulationId, simulationsDailyLoadsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdDailyLoadsPost(simulationId, simulationsDailyLoadsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdDailyLoadsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsDisabledEventsGetRequest} [simulationsDisabledEventsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdDisabledEventsPost(simulationId, simulationsDisabledEventsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdDisabledEventsPost(simulationId, simulationsDisabledEventsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdDisabledEventsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationEventFieldsGetRequest} [simulationEventFieldsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdEventFieldsPost(simulationId, simulationEventFieldsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdEventFieldsPost(simulationId, simulationEventFieldsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdEventFieldsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsEventsInfosGetRequest} [simulationsEventsInfosGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdEventsInfosPost(simulationId, simulationsEventsInfosGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdEventsInfosPost(simulationId, simulationsEventsInfosGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdEventsInfosPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsImportsGetRequest} [simulationsImportsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdImportsPost(simulationId, simulationsImportsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdImportsPost(simulationId, simulationsImportsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdImportsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsLoadGraphGetRequest} [simulationsLoadGraphGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadGraphPost(simulationId, simulationsLoadGraphGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdLoadGraphPost(simulationId, simulationsLoadGraphGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdLoadGraphPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsLoadsFullGetRequest} [simulationsLoadsFullGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadsFullPost(simulationId, simulationsLoadsFullGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdLoadsFullPost(simulationId, simulationsLoadsFullGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdLoadsFullPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsLoadsGetRequest} [simulationsLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadsPost(simulationId, simulationsLoadsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdLoadsPost(simulationId, simulationsLoadsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdLoadsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsRawLoadsGetRequest} [simulationsRawLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadsRawPost(simulationId, simulationsRawLoadsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdLoadsRawPost(simulationId, simulationsRawLoadsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdLoadsRawPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdOfsLastDoneDatePost(simulationId, body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdOfsLastDoneDatePost(simulationId, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdOfsLastDoneDatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdOfsPost(simulationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdOfsPost(simulationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdOfsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdOpsPost(simulationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdOpsPost(simulationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdOpsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationSectorsLoadsGetRequest} [simulationSectorsLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdSectorsLoadsPost(simulationId, simulationSectorsLoadsGetRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsSimulationIdSectorsLoadsPost(simulationId, simulationSectorsLoadsGetRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsSimulationIdSectorsLoadsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SimulationUpdateFromSchedulingRequest} [simulationUpdateFromSchedulingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsUpdateLoadFromSchedulingPost(simulationUpdateFromSchedulingRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSimulationsUpdateLoadFromSchedulingPost(simulationUpdateFromSchedulingRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSimulationsUpdateLoadFromSchedulingPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSpecificSaintGobainSullyLastUpdatesGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiSpecificSaintGobainSullyLastUpdatesGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiSpecificSaintGobainSullyLastUpdatesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AdjustProdObjectiveRequest} [adjustProdObjectiveRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksAdjustProdObjectivePost(adjustProdObjectiveRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiStocksAdjustProdObjectivePost(adjustProdObjectiveRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiStocksAdjustProdObjectivePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {StocksGetDemandRequest} [stocksGetDemandRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksGetDemandPost(stocksGetDemandRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiStocksGetDemandPost(stocksGetDemandRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiStocksGetDemandPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {StocksGetOverloadedSectorsByArticlesRequest} [stocksGetOverloadedSectorsByArticlesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksGetOverloadedSectorsByArticlesPost(stocksGetOverloadedSectorsByArticlesRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiStocksGetOverloadedSectorsByArticlesPost(stocksGetOverloadedSectorsByArticlesRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiStocksGetOverloadedSectorsByArticlesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {StocksSetDemandRequest} [stocksSetDemandRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksSetDemandPost(stocksSetDemandRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiStocksSetDemandPost(stocksSetDemandRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiStocksSetDemandPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTasksPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiTasksPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiTasksPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersCheckLastLoginPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersCheckLastLoginPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiUsersCheckLastLoginPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersFlushCacheGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersFlushCacheGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiUsersFlushCacheGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUpdateFromFirebasePost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersUpdateFromFirebasePost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.apiUsersUpdateFromFirebasePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ValidatePasswordExpirationRouteRequest} [validatePasswordExpirationRouteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authValidatePasswordExpirationPost(validatePasswordExpirationRouteRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authValidatePasswordExpirationPost(validatePasswordExpirationRouteRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.authValidatePasswordExpirationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {BalanceLoadToCapacityRequest} [balanceLoadToCapacityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceLoadToCapacity(balanceLoadToCapacityRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.balanceLoadToCapacity(balanceLoadToCapacityRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.balanceLoadToCapacity']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bigqueryGetPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bigqueryGetPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.bigqueryGetPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ProdObjectiveTransferRequest} [prodObjectiveTransferRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProdObjectiveTransfer(prodObjectiveTransferRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createProdObjectiveTransfer(prodObjectiveTransferRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.createProdObjectiveTransfer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DailyCapacityAndTotalCapacityByDateRequest} [dailyCapacityAndTotalCapacityByDateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyCapacityAndTotalCapacityByDate(dailyCapacityAndTotalCapacityByDateRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDailyCapacityAndTotalCapacityByDate(dailyCapacityAndTotalCapacityByDateRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getDailyCapacityAndTotalCapacityByDate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} opId
         * @param {string} simulationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestLoadEventsRowsByOpId(opId, simulationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLatestLoadEventsRowsByOpId(opId, simulationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getLatestLoadEventsRowsByOpId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {LoadRateAndRemainingCapacityRequest} [loadRateAndRemainingCapacityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadRateAndRemainingCapacity(loadRateAndRemainingCapacityRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLoadRateAndRemainingCapacity(loadRateAndRemainingCapacityRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getLoadRateAndRemainingCapacity']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {SchedulingGetAnalyticsRequest} [schedulingGetAnalyticsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingAnalytics(simulationId, schedulingGetAnalyticsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchedulingAnalytics(simulationId, schedulingGetAnalyticsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getSchedulingAnalytics']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingComponentsGetComponentAnalyticsRequest} [schedulingComponentsGetComponentAnalyticsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentAnalytics(schedulingComponentsGetComponentAnalyticsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchedulingComponentsComponentAnalytics(schedulingComponentsGetComponentAnalyticsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getSchedulingComponentsComponentAnalytics']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingComponentsGetComponentDetailsRequest} [schedulingComponentsGetComponentDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentDetails(schedulingComponentsGetComponentDetailsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchedulingComponentsComponentDetails(schedulingComponentsGetComponentDetailsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getSchedulingComponentsComponentDetails']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingComponentsGetComponentInitialStockRequest} [schedulingComponentsGetComponentInitialStockRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentInitialStock(schedulingComponentsGetComponentInitialStockRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchedulingComponentsComponentInitialStock(schedulingComponentsGetComponentInitialStockRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getSchedulingComponentsComponentInitialStock']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingComponentsGetComponentsCurrentStocksRequest} [schedulingComponentsGetComponentsCurrentStocksRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentsCurrentStocks(schedulingComponentsGetComponentsCurrentStocksRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchedulingComponentsComponentsCurrentStocks(schedulingComponentsGetComponentsCurrentStocksRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getSchedulingComponentsComponentsCurrentStocks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SchedulingComponentsGetSidebarComponentsDetailsRequest} [schedulingComponentsGetSidebarComponentsDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsSidebarComponentsDetails(schedulingComponentsGetSidebarComponentsDetailsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchedulingComponentsSidebarComponentsDetails(schedulingComponentsGetSidebarComponentsDetailsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getSchedulingComponentsSidebarComponentsDetails']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} simulationId
         * @param {string} ofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationsOfsParams(simulationId, ofId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSimulationsOfsParams(simulationId, ofId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getSimulationsOfsParams']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {StocksGetDemandByArticlesRequest} [stocksGetDemandByArticlesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksDemandByArticles(stocksGetDemandByArticlesRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStocksDemandByArticles(stocksGetDemandByArticlesRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getStocksDemandByArticles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {StocksGetObjectiveByArticlesRequest} [stocksGetObjectiveByArticlesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksObjectiveByArticles(stocksGetObjectiveByArticlesRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStocksObjectiveByArticles(stocksGetObjectiveByArticlesRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getStocksObjectiveByArticles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksSectorsIdsFromGammes(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStocksSectorsIdsFromGammes(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getStocksSectorsIdsFromGammes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {StocksGetStocksTableRequest} [stocksGetStocksTableRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksTable(stocksGetStocksTableRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStocksTable(stocksGetStocksTableRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getStocksTable']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFilePost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importFilePost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.importFilePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowsPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importRowsPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.importRowsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importSignedUrlGet(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importSignedUrlGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.importSignedUrlGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importUpdateDataB2bPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importUpdateDataB2bPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.importUpdateDataB2bPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importUpdateDataPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importUpdateDataPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.importUpdateDataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyOnOplitDateParametersUpdate(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.notifyOnOplitDateParametersUpdate(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.notifyOnOplitDateParametersUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pgParserPost(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pgParserPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.pgParserPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOPsUpdatesToSGS(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendOPsUpdatesToSGS(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.sendOPsUpdatesToSGS']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {MicrosoftRoleSyncRouteRequest} [microsoftRoleSyncRouteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMicrosoftRoles(microsoftRoleSyncRouteRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncMicrosoftRoles(microsoftRoleSyncRouteRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.syncMicrosoftRoles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SyncOIDCUserRouteRequest} [syncOIDCUserRouteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOIDCUser(syncOIDCUserRouteRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncOIDCUser(syncOIDCUserRouteRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.syncOIDCUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DefaultApiFp(configuration);
    return {
        /**
         *
         * @param {any} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminHackyDevFnsPost(body, options) {
            return localVarFp.apiAdminHackyDevFnsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminInfraCostsByClientGet(options) {
            return localVarFp.apiAdminInfraCostsByClientGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetCrossingTimesByArticleRequest} [getCrossingTimesByArticleRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsCrossingTimesByArticlePost(getCrossingTimesByArticleRequest, options) {
            return localVarFp.apiAnalyticsCrossingTimesByArticlePost(getCrossingTimesByArticleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsCrossingTimesPost(body, options) {
            return localVarFp.apiAnalyticsCrossingTimesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AnalyticsOfsEndTimeRequest} [analyticsOfsEndTimeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsEndTimePost(analyticsOfsEndTimeRequest, options) {
            return localVarFp.apiAnalyticsEndTimePost(analyticsOfsEndTimeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AnalyticsFiltersRequest} [analyticsFiltersRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsFiltersPost(analyticsFiltersRequest, options) {
            return localVarFp.apiAnalyticsFiltersPost(analyticsFiltersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetOPsByOFRequest} [getOPsByOFRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsGetOpsByOfPost(getOPsByOFRequest, options) {
            return localVarFp.apiAnalyticsGetOpsByOfPost(getOPsByOFRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AnalyticsOFRequest} [analyticsOFRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsOfsPost(analyticsOFRequest, options) {
            return localVarFp.apiAnalyticsOfsPost(analyticsOFRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AnalyticsProgressRequest} [analyticsProgressRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsProgressPost(analyticsProgressRequest, options) {
            return localVarFp.apiAnalyticsProgressPost(analyticsProgressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AnalyticsStagnationRequest} [analyticsStagnationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsStagnationPost(analyticsStagnationRequest, options) {
            return localVarFp.apiAnalyticsStagnationPost(analyticsStagnationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AnalyticsOfsStartedOnTimeRequest} [analyticsOfsStartedOnTimeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsStartedOnTimePost(analyticsOfsStartedOnTimeRequest, options) {
            return localVarFp.apiAnalyticsStartedOnTimePost(analyticsOfsStartedOnTimeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AnalyticsWIPRequest} [analyticsWIPRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnalyticsWipPost(analyticsWIPRequest, options) {
            return localVarFp.apiAnalyticsWipPost(analyticsWIPRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RecoverImportPostRequest} [recoverImportPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArchivesRecoverImportPost(recoverImportPostRequest, options) {
            return localVarFp.apiArchivesRecoverImportPost(recoverImportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RecoverSimulationPostRequest} [recoverSimulationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArchivesRecoverSimulationPost(recoverSimulationPostRequest, options) {
            return localVarFp.apiArchivesRecoverSimulationPost(recoverSimulationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ArticlesGetRequest} [articlesGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticlePost(articlesGetRequest, options) {
            return localVarFp.apiArticlePost(articlesGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ArticlesGetRequest} [articlesGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArticleTargetStockPost(articlesGetRequest, options) {
            return localVarFp.apiArticleTargetStockPost(articlesGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetWorkdaysPostRequest} [getWorkdaysPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalendarGetWorkdaysPost(getWorkdaysPostRequest, options) {
            return localVarFp.apiCalendarGetWorkdaysPost(getWorkdaysPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SaveCalendarRequest} [saveCalendarRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalendarSaveCalendarPost(saveCalendarRequest, options) {
            return localVarFp.apiCalendarSaveCalendarPost(saveCalendarRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalendarTestPost(body, options) {
            return localVarFp.apiCalendarTestPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CalculateCapaRequest} [calculateCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesCalculateCapaPost(calculateCapaRequest, options) {
            return localVarFp.apiCapacitiesCalculateCapaPost(calculateCapaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DailyCapacityRequest} [dailyCapacityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesDailyPost(dailyCapacityRequest, options) {
            return localVarFp.apiCapacitiesDailyPost(dailyCapacityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DailyTotalCapaRequest} [dailyTotalCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesDailyTotalCapaPost(dailyTotalCapaRequest, options) {
            return localVarFp.apiCapacitiesDailyTotalCapaPost(dailyTotalCapaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FullTimeNeedRequest} [fullTimeNeedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesFullTimeNeedPost(fullTimeNeedRequest, options) {
            return localVarFp.apiCapacitiesFullTimeNeedPost(fullTimeNeedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NeededOrgaRequest} [neededOrgaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesNeededOrgaPost(neededOrgaRequest, options) {
            return localVarFp.apiCapacitiesNeededOrgaPost(neededOrgaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OverloadedSectorsRequest} [overloadedSectorsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesOverloadedSectorsPost(overloadedSectorsRequest, options) {
            return localVarFp.apiCapacitiesOverloadedSectorsPost(overloadedSectorsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TotalCapaRequest} [totalCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesTotalCapaPost(totalCapaRequest, options) {
            return localVarFp.apiCapacitiesTotalCapaPost(totalCapaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TotalRemainingCapaRequest} [totalRemainingCapaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCapacitiesTotalRemainingCapaPost(totalRemainingCapaRequest, options) {
            return localVarFp.apiCapacitiesTotalRemainingCapaPost(totalRemainingCapaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ClientsCreateRequest} [clientsCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsPost(clientsCreateRequest, options) {
            return localVarFp.apiClientsPost(clientsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CrispHasNewProductReleaseRequest} [crispHasNewProductReleaseRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsCrispHasNewProductReleasePost(crispHasNewProductReleaseRequest, options) {
            return localVarFp.apiConnectorsCrispHasNewProductReleasePost(crispHasNewProductReleaseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsCrispWebhooksPost(options) {
            return localVarFp.apiConnectorsCrispWebhooksPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CapaBySectorRequest} [capaBySectorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsExternalCapaBySectorPost(capaBySectorRequest, options) {
            return localVarFp.apiConnectorsExternalCapaBySectorPost(capaBySectorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsExternalSectorsGet(options) {
            return localVarFp.apiConnectorsExternalSectorsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AddCyclePostRequest} [addCyclePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearAddCyclePost(addCyclePostRequest, options) {
            return localVarFp.apiConnectorsLinearAddCyclePost(addCyclePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearListCyclesPost(body, options) {
            return localVarFp.apiConnectorsLinearListCyclesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CycleIdRequest} [cycleIdRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearLoadCycleDataPost(cycleIdRequest, options) {
            return localVarFp.apiConnectorsLinearLoadCycleDataPost(cycleIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SupportDateRangeRequest} [supportDateRangeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearLoadSupportDataPost(supportDateRangeRequest, options) {
            return localVarFp.apiConnectorsLinearLoadSupportDataPost(supportDateRangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SaveTeamDataPointRequest} [saveTeamDataPointRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearSaveTeamDataPointPost(saveTeamDataPointRequest, options) {
            return localVarFp.apiConnectorsLinearSaveTeamDataPointPost(saveTeamDataPointRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LinearTechKPIsPostRequest} [linearTechKPIsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearTechKpisPost(linearTechKPIsPostRequest, options) {
            return localVarFp.apiConnectorsLinearTechKpisPost(linearTechKPIsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearTimeCalculatorPost(body, options) {
            return localVarFp.apiConnectorsLinearTimeCalculatorPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearUpdateLabelsPost(options) {
            return localVarFp.apiConnectorsLinearUpdateLabelsPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsLinearWebhooksPost(options) {
            return localVarFp.apiConnectorsLinearWebhooksPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {M3ExtractionRequest} [m3ExtractionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectorsM3ExtractDataPost(m3ExtractionRequest, options) {
            return localVarFp.apiConnectorsM3ExtractDataPost(m3ExtractionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetCustomersDetailsGet(options) {
            return localVarFp.apiCustomerInterfaceGetCustomersDetailsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetFiltersGet(options) {
            return localVarFp.apiCustomerInterfaceGetFiltersGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CustomerInterfaceGetOfsDetailsRequest} [customerInterfaceGetOfsDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetOfsDetailsPost(customerInterfaceGetOfsDetailsRequest, options) {
            return localVarFp.apiCustomerInterfaceGetOfsDetailsPost(customerInterfaceGetOfsDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceGetProviderIdsGet(options) {
            return localVarFp.apiCustomerInterfaceGetProviderIdsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CustomerInterfaceListOfsGetRequest} [customerInterfaceListOfsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerInterfaceListOfsPost(customerInterfaceListOfsGetRequest, options) {
            return localVarFp.apiCustomerInterfaceListOfsPost(customerInterfaceListOfsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DailyDelaysGetRequest} [dailyDelaysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDailyDelaysPost(dailyDelaysGetRequest, options) {
            return localVarFp.apiDailyDelaysPost(dailyDelaysGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DelaysBySectorGetRequest} [delaysBySectorGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDelaysPost(delaysBySectorGetRequest, options) {
            return localVarFp.apiDelaysPost(delaysBySectorGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EventsGetRequest} [eventsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsDetailsPost(eventsGetRequest, options) {
            return localVarFp.apiEventsDetailsPost(eventsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EventsFieldsGetRequest} [eventsFieldsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsFieldsPost(eventsFieldsGetRequest, options) {
            return localVarFp.apiEventsFieldsPost(eventsFieldsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EventsGetSimpleEventsPostRequest} [eventsGetSimpleEventsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsGetSimpleEventsPost(eventsGetSimpleEventsPostRequest, options) {
            return localVarFp.apiEventsGetSimpleEventsPost(eventsGetSimpleEventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EventsMigratePostRequest} [eventsMigratePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsMigratePost(eventsMigratePostRequest, options) {
            return localVarFp.apiEventsMigratePost(eventsMigratePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsOnChangePost(options) {
            return localVarFp.apiEventsOnChangePost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsOnChangeSsePost(options) {
            return localVarFp.apiEventsOnChangeSsePost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {any | Array<any>} [anyArrayany]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsPushPost(anyArrayany, options) {
            return localVarFp.apiEventsPushPost(anyArrayany, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqCheckConnectionGet(options) {
            return localVarFp.apiFabriqCheckConnectionGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqCreateTicketTicketIdPost(ticketId, options) {
            return localVarFp.apiFabriqCreateTicketTicketIdPost(ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqDeleteTicketTicketIdPost(ticketId, options) {
            return localVarFp.apiFabriqDeleteTicketTicketIdPost(ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} ticketId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqGetTicketTicketIdGet(ticketId, options) {
            return localVarFp.apiFabriqGetTicketTicketIdGet(ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFabriqGetUsersGet(options) {
            return localVarFp.apiFabriqGetUsersGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GammesGetRequest} [gammesGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGammesPost(gammesGetRequest, options) {
            return localVarFp.apiGammesPost(gammesGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetDownloadURLRequest} [getDownloadURLRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetDownloadUrlPost(getDownloadURLRequest, options) {
            return localVarFp.apiGetDownloadUrlPost(getDownloadURLRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ImportsDetailedInitialStocksRequest} [importsDetailedInitialStocksRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsDetailedInitialStocksPost(importsDetailedInitialStocksRequest, options) {
            return localVarFp.apiImportsDetailedInitialStocksPost(importsDetailedInitialStocksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ImportErrorLogsRequestBody} [importErrorLogsRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsErrorLogsPost(importErrorLogsRequestBody, options) {
            return localVarFp.apiImportsErrorLogsPost(importErrorLogsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ImportsFieldsKeysGetRequest} [importsFieldsKeysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsFieldsKeysPost(importsFieldsKeysGetRequest, options) {
            return localVarFp.apiImportsFieldsKeysPost(importsFieldsKeysGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ImportsGenerateFileRequest} [importsGenerateFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsGenerateImportFilePost(importsGenerateFileRequest, options) {
            return localVarFp.apiImportsGenerateImportFilePost(importsGenerateFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetImportUnitsRequest} [getImportUnitsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsGetImportUnitsPost(getImportUnitsRequest, options) {
            return localVarFp.apiImportsGetImportUnitsPost(getImportUnitsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} importId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdArticlesRefsPost(importId, body, options) {
            return localVarFp.apiImportsImportIdArticlesRefsPost(importId, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} importId
         * @param {ImportsDailyRawLoadsGetRequest} [importsDailyRawLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdDailyRawLoadsPost(importId, importsDailyRawLoadsGetRequest, options) {
            return localVarFp.apiImportsImportIdDailyRawLoadsPost(importId, importsDailyRawLoadsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} importId
         * @param {ImportsSpecificLoadsGetRequest} [importsSpecificLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdLoadsPost(importId, importsSpecificLoadsGetRequest, options) {
            return localVarFp.apiImportsImportIdLoadsPost(importId, importsSpecificLoadsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} importId
         * @param {string} ofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportIdOfsOfIdLastDateGet(importId, ofId, options) {
            return localVarFp.apiImportsImportIdOfsOfIdLastDateGet(importId, ofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ImportLogsRequestBody} [importLogsRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsImportLogsPost(importLogsRequestBody, options) {
            return localVarFp.apiImportsImportLogsPost(importLogsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ImportsInitialStocksRequest} [importsInitialStocksRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsInitialStocksPost(importsInitialStocksRequest, options) {
            return localVarFp.apiImportsInitialStocksPost(importsInitialStocksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ImportsLastRequest} [importsLastRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsLastPost(importsLastRequest, options) {
            return localVarFp.apiImportsLastPost(importsLastRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ImportsLateRequest} [importsLateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsLatePost(importsLateRequest, options) {
            return localVarFp.apiImportsLatePost(importsLateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ImportsLoadsGetRequest} [importsLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsLoadsPost(importsLoadsGetRequest, options) {
            return localVarFp.apiImportsLoadsPost(importsLoadsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ImportsSkippedRequest} [importsSkippedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportsSkippedPost(importsSkippedRequest, options) {
            return localVarFp.apiImportsSkippedPost(importsSkippedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LaunchPgMigrateRequest} [launchPgMigrateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLaunchPgMigratePost(launchPgMigrateRequest, options) {
            return localVarFp.apiLaunchPgMigratePost(launchPgMigrateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetAbsencesGet(options) {
            return localVarFp.apiMercateamGetAbsencesGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetEmployeesListGet(options) {
            return localVarFp.apiMercateamGetEmployeesListGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetPlanningsGet(options) {
            return localVarFp.apiMercateamGetPlanningsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetSectorsPost(options) {
            return localVarFp.apiMercateamGetSectorsPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamGetStatusGet(options) {
            return localVarFp.apiMercateamGetStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamSavePlanningsPost(options) {
            return localVarFp.apiMercateamSavePlanningsPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMercateamSaveUnexpectedEventsPost(options) {
            return localVarFp.apiMercateamSaveUnexpectedEventsPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DbHelperProxyPostRequest} [dbHelperProxyPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationDbhelperProxyPost(dbHelperProxyPostRequest, options) {
            return localVarFp.apiMigrationDbhelperProxyPost(dbHelperProxyPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MigrateToTargetPostRequest} [migrateToTargetPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationMigrateToTargetPost(migrateToTargetPostRequest, options) {
            return localVarFp.apiMigrationMigrateToTargetPost(migrateToTargetPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PGProxyPostRequest} [pGProxyPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMigrationPgProxyPost(pGProxyPostRequest, options) {
            return localVarFp.apiMigrationPgProxyPost(pGProxyPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNomenclaturesGetAllGet(options) {
            return localVarFp.apiNomenclaturesGetAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NomenclaturesPostRequestUpdate} [nomenclaturesPostRequestUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNomenclaturesUpdatePost(nomenclaturesPostRequestUpdate, options) {
            return localVarFp.apiNomenclaturesUpdatePost(nomenclaturesPostRequestUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OplitCopilotTriggerCopilotReschedulingPostRequest} [oplitCopilotTriggerCopilotReschedulingPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitCopilotTriggerCopilotRescheduling(oplitCopilotTriggerCopilotReschedulingPostRequest, options) {
            return localVarFp.apiOplitCopilotTriggerCopilotRescheduling(oplitCopilotTriggerCopilotReschedulingPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OplitDateGetCsvWithOplitDatePostRequest} [oplitDateGetCsvWithOplitDatePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGenerateCSVDoneOFsHistory(oplitDateGetCsvWithOplitDatePostRequest, options) {
            return localVarFp.apiOplitDateGenerateCSVDoneOFsHistory(oplitDateGetCsvWithOplitDatePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OplitDateGetCsvWithOplitDatePostRequest} [oplitDateGetCsvWithOplitDatePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGenerateCSVOngoingOFsEstimations(oplitDateGetCsvWithOplitDatePostRequest, options) {
            return localVarFp.apiOplitDateGenerateCSVOngoingOFsEstimations(oplitDateGetCsvWithOplitDatePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetClientFeatures(options) {
            return localVarFp.apiOplitDateGetClientFeatures(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetClientOFs(options) {
            return localVarFp.apiOplitDateGetClientOFs(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetClientTeamSettings(options) {
            return localVarFp.apiOplitDateGetClientTeamSettings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OplitDateGetCsvWithOfHistoryPostRequest} [oplitDateGetCsvWithOfHistoryPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetCsvWithOfHistory(oplitDateGetCsvWithOfHistoryPostRequest, options) {
            return localVarFp.apiOplitDateGetCsvWithOfHistory(oplitDateGetCsvWithOfHistoryPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetImpactedScopes(options) {
            return localVarFp.apiOplitDateGetImpactedScopes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateGetLastUpdate(options) {
            return localVarFp.apiOplitDateGetLastUpdate(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OplitDateSaveClientFeaturesPostRequest} [oplitDateSaveClientFeaturesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateSaveClientFeatures(oplitDateSaveClientFeaturesPostRequest, options) {
            return localVarFp.apiOplitDateSaveClientFeatures(oplitDateSaveClientFeaturesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OplitDateSaveOplitDateTeamSettingsPostRequest} [oplitDateSaveOplitDateTeamSettingsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOplitDateSaveOplitDateTeamSettings(oplitDateSaveOplitDateTeamSettingsPostRequest, options) {
            return localVarFp.apiOplitDateSaveOplitDateTeamSettings(oplitDateSaveOplitDateTeamSettingsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PdpLoadGetInitialLoadsRequest} [pdpLoadGetInitialLoadsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadGetInitialLoadsPost(pdpLoadGetInitialLoadsRequest, options) {
            return localVarFp.apiPdpLoadGetInitialLoadsPost(pdpLoadGetInitialLoadsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PdpLoadGetLoadEventsRequest} [pdpLoadGetLoadEventsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadGetLoadEventsPost(pdpLoadGetLoadEventsRequest, options) {
            return localVarFp.apiPdpLoadGetLoadEventsPost(pdpLoadGetLoadEventsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PdpLoadGetSectorChargePostRequest} [pdpLoadGetSectorChargePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadGetSectorChargePost(pdpLoadGetSectorChargePostRequest, options) {
            return localVarFp.apiPdpLoadGetSectorChargePost(pdpLoadGetSectorChargePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadHasSectorChargeFormulaGet(options) {
            return localVarFp.apiPdpLoadHasSectorChargeFormulaGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PdpLoadSaveLoadEventRequest} [pdpLoadSaveLoadEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadSaveLoadEventPost(pdpLoadSaveLoadEventRequest, options) {
            return localVarFp.apiPdpLoadSaveLoadEventPost(pdpLoadSaveLoadEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PdpLoadUpdateLoadEventRequest} [pdpLoadUpdateLoadEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPdpLoadUpdateLoadEventPost(pdpLoadUpdateLoadEventRequest, options) {
            return localVarFp.apiPdpLoadUpdateLoadEventPost(pdpLoadUpdateLoadEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PgTriggersPostRequest} [pgTriggersPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPgTriggersPost(pgTriggersPostRequest, options) {
            return localVarFp.apiPgTriggersPost(pgTriggersPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AbsencesByOperatorRequest} [absencesByOperatorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningAbsencesByOperatorPost(absencesByOperatorRequest, options) {
            return localVarFp.apiPlanningAbsencesByOperatorPost(absencesByOperatorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DailyPlanningRequest} [dailyPlanningRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningDailyPlanningPost(dailyPlanningRequest, options) {
            return localVarFp.apiPlanningDailyPlanningPost(dailyPlanningRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {IsGoulotRequest} [isGoulotRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningIsGoulotPost(isGoulotRequest, options) {
            return localVarFp.apiPlanningIsGoulotPost(isGoulotRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MachinesByOperatorRequest} [machinesByOperatorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningMachinesByOperatorPost(machinesByOperatorRequest, options) {
            return localVarFp.apiPlanningMachinesByOperatorPost(machinesByOperatorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MachinesBySectorRequest} [machinesBySectorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningMachinesBySectorPost(machinesBySectorRequest, options) {
            return localVarFp.apiPlanningMachinesBySectorPost(machinesBySectorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CustomMSDFieldValueRequest} [customMSDFieldValueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningMsdFieldValuePost(customMSDFieldValueRequest, options) {
            return localVarFp.apiPlanningMsdFieldValuePost(customMSDFieldValueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OperatorsByMachineRequest} [operatorsByMachineRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningOperatorsByMachinePost(operatorsByMachineRequest, options) {
            return localVarFp.apiPlanningOperatorsByMachinePost(operatorsByMachineRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OperatorsBySectorRequest} [operatorsBySectorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningOperatorsBySectorPost(operatorsBySectorRequest, options) {
            return localVarFp.apiPlanningOperatorsBySectorPost(operatorsBySectorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PeriodesOrgaRequest} [periodesOrgaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningPeriodesOrgaPost(periodesOrgaRequest, options) {
            return localVarFp.apiPlanningPeriodesOrgaPost(periodesOrgaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SaveStandardPlanningRequest} [saveStandardPlanningRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanningSaveStandardPlanningPost(saveStandardPlanningRequest, options) {
            return localVarFp.apiPlanningSaveStandardPlanningPost(saveStandardPlanningRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductionsAllGetRequest} [productionsAllGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionsAllPost(productionsAllGetRequest, options) {
            return localVarFp.apiProductionsAllPost(productionsAllGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductionsLastProdUpdateGetRequest} [productionsLastProdUpdateGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionsLastProdUpdatePost(productionsLastProdUpdateGetRequest, options) {
            return localVarFp.apiProductionsLastProdUpdatePost(productionsLastProdUpdateGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPubsubPost(options) {
            return localVarFp.apiPubsubPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingAiPost(options) {
            return localVarFp.apiSchedulingAiPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingCancelLastSchedulingAIRequest} [schedulingCancelLastSchedulingAIRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingCancelLastReschedulingAiPost(schedulingCancelLastSchedulingAIRequest, options) {
            return localVarFp.apiSchedulingCancelLastReschedulingAiPost(schedulingCancelLastSchedulingAIRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingGetConwipTicketsGaugesPostRequest} [schedulingGetConwipTicketsGaugesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetConwipTicketsGaugesPost(schedulingGetConwipTicketsGaugesPostRequest, options) {
            return localVarFp.apiSchedulingGetConwipTicketsGaugesPost(schedulingGetConwipTicketsGaugesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingGetNextAvailableCapaDayRequest} [schedulingGetNextAvailableCapaDayRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetNextAvailableCapaDayPost(schedulingGetNextAvailableCapaDayRequest, options) {
            return localVarFp.apiSchedulingGetNextAvailableCapaDayPost(schedulingGetNextAvailableCapaDayRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingGetOFUpdateDateRequest} [schedulingGetOFUpdateDateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetOFUpdateDate(schedulingGetOFUpdateDateRequest, options) {
            return localVarFp.apiSchedulingGetOFUpdateDate(schedulingGetOFUpdateDateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingGetOfsFiltersRequest} [schedulingGetOfsFiltersRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetOfsFiltersPost(schedulingGetOfsFiltersRequest, options) {
            return localVarFp.apiSchedulingGetOfsFiltersPost(schedulingGetOfsFiltersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetParametersOfDisplayGet(options) {
            return localVarFp.apiSchedulingGetParametersOfDisplayGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingGetQuantiteOFRequest} [schedulingGetQuantiteOFRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetQuantiteOfPost(schedulingGetQuantiteOFRequest, options) {
            return localVarFp.apiSchedulingGetQuantiteOfPost(schedulingGetQuantiteOFRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingGetReschedulingLogsRequest} [schedulingGetReschedulingLogsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetReschedulingLogsPost(schedulingGetReschedulingLogsRequest, options) {
            return localVarFp.apiSchedulingGetReschedulingLogsPost(schedulingGetReschedulingLogsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingGetSimulationLastImportDataRequest} [schedulingGetSimulationLastImportDataRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetSimulationLastImportData(schedulingGetSimulationLastImportDataRequest, options) {
            return localVarFp.apiSchedulingGetSimulationLastImportData(schedulingGetSimulationLastImportDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingGetSubOFsRequest} [schedulingGetSubOFsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingGetSubOfsPost(schedulingGetSubOFsRequest, options) {
            return localVarFp.apiSchedulingGetSubOfsPost(schedulingGetSubOFsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingListOfsGetRequest} [schedulingListOfsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingListOfsPost(schedulingListOfsGetRequest, options) {
            return localVarFp.apiSchedulingListOfsPost(schedulingListOfsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingMachineCentersPost(options) {
            return localVarFp.apiSchedulingMachineCentersPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingProductionOrdersLeadTimesPost(options) {
            return localVarFp.apiSchedulingProductionOrdersLeadTimesPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SaveRealtimeSchedulingEventsPostRequest} [saveRealtimeSchedulingEventsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingSaveRealtimeSchedulingEventsPost(saveRealtimeSchedulingEventsPostRequest, options) {
            return localVarFp.apiSchedulingSaveRealtimeSchedulingEventsPost(saveRealtimeSchedulingEventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SaveSchedulingEventsPostRequest} [saveSchedulingEventsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingSaveSchedulingEventsPost(saveSchedulingEventsPostRequest, options) {
            return localVarFp.apiSchedulingSaveSchedulingEventsPost(saveSchedulingEventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingSseProductionOrdersPost(options) {
            return localVarFp.apiSchedulingSseProductionOrdersPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateCapacityFromSimulationPostRequest} [updateCapacityFromSimulationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingUpdateCapacityFromSimulationPost(updateCapacityFromSimulationPostRequest, options) {
            return localVarFp.apiSchedulingUpdateCapacityFromSimulationPost(updateCapacityFromSimulationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingUpdateConwipTicketsGaugesPostRequest} [schedulingUpdateConwipTicketsGaugesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchedulingUpdateConwipTicketsGaugesPost(schedulingUpdateConwipTicketsGaugesPostRequest, options) {
            return localVarFp.apiSchedulingUpdateConwipTicketsGaugesPost(schedulingUpdateConwipTicketsGaugesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SectorsAutoOrgaGetRequest} [sectorsAutoOrgaGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsAutoOrgaPost(sectorsAutoOrgaGetRequest, options) {
            return localVarFp.apiSectorsAutoOrgaPost(sectorsAutoOrgaGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsClientAutoOrgaGet(options) {
            return localVarFp.apiSectorsClientAutoOrgaGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SectorsFromTypeWithMoveXGetRequest} [sectorsFromTypeWithMoveXGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsFromTypeWithMovexPost(sectorsFromTypeWithMoveXGetRequest, options) {
            return localVarFp.apiSectorsFromTypeWithMovexPost(sectorsFromTypeWithMoveXGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetAllSectorsInClientGroupRequest} [getAllSectorsInClientGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsGetAllSectorsInClientGroup(getAllSectorsInClientGroupRequest, options) {
            return localVarFp.apiSectorsGetAllSectorsInClientGroup(getAllSectorsInClientGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsCalendarsRequest} [sectorsCalendarsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdCalendarsPost(secteurId, sectorsCalendarsRequest, options) {
            return localVarFp.apiSectorsSecteurIdCalendarsPost(secteurId, sectorsCalendarsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdDefaultCapacitiesPost(secteurId, options) {
            return localVarFp.apiSectorsSecteurIdDefaultCapacitiesPost(secteurId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {string} importId
         * @param {SectorsImportsDelaysGetRequest} [sectorsImportsDelaysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdDelaysImportIdPost(secteurId, importId, sectorsImportsDelaysGetRequest, options) {
            return localVarFp.apiSectorsSecteurIdDelaysImportIdPost(secteurId, importId, sectorsImportsDelaysGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsDelaysGetRequest} [sectorsDelaysGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdDelaysPost(secteurId, sectorsDelaysGetRequest, options) {
            return localVarFp.apiSectorsSecteurIdDelaysPost(secteurId, sectorsDelaysGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdFormulasGet(secteurId, options) {
            return localVarFp.apiSectorsSecteurIdFormulasGet(secteurId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdMercateamAvailableOperatorsGet(secteurId, options) {
            return localVarFp.apiSectorsSecteurIdMercateamAvailableOperatorsGet(secteurId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdMsdParametersGet(secteurId, options) {
            return localVarFp.apiSectorsSecteurIdMsdParametersGet(secteurId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsOperatorsGetRequest} [sectorsOperatorsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdOperatorsPost(secteurId, sectorsOperatorsGetRequest, options) {
            return localVarFp.apiSectorsSecteurIdOperatorsPost(secteurId, sectorsOperatorsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdParametersFieldsGet(secteurId, options) {
            return localVarFp.apiSectorsSecteurIdParametersFieldsGet(secteurId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {SectorsParametersGetRequest} [sectorsParametersGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdParametersPost(secteurId, sectorsParametersGetRequest, options) {
            return localVarFp.apiSectorsSecteurIdParametersPost(secteurId, sectorsParametersGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} secteurId Secteur ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSectorsSecteurIdUnitsGet(secteurId, options) {
            return localVarFp.apiSectorsSecteurIdUnitsGet(secteurId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LoggingGetRequest} [loggingGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerLogPost(loggingGetRequest, options) {
            return localVarFp.apiServerLogPost(loggingGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} filePath
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShuffledGet(filePath, options) {
            return localVarFp.apiShuffledGet(filePath, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SimulationsLoadsFullGetRequest} [simulationsLoadsFullGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsAbsoluteLoadsFullPost(simulationsLoadsFullGetRequest, options) {
            return localVarFp.apiSimulationsAbsoluteLoadsFullPost(simulationsLoadsFullGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} ofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsAbsoluteOfsOfIdLastDateGet(ofId, options) {
            return localVarFp.apiSimulationsAbsoluteOfsOfIdLastDateGet(ofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SimulationsCreatePostRequest} [simulationsCreatePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsCreatePost(simulationsCreatePostRequest, options) {
            return localVarFp.apiSimulationsCreatePost(simulationsCreatePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SimulationsGanttLoadsGetRequest} [simulationsGanttLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGanttLoadsPost(simulationsGanttLoadsGetRequest, options) {
            return localVarFp.apiSimulationsGanttLoadsPost(simulationsGanttLoadsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetGroupSynthesisAvailableClientIDs(options) {
            return localVarFp.apiSimulationsGetGroupSynthesisAvailableClientIDs(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetGroupSynthesisTableDataRequest} [getGroupSynthesisTableDataRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetGroupSynthesisTableData(getGroupSynthesisTableDataRequest, options) {
            return localVarFp.apiSimulationsGetGroupSynthesisTableData(getGroupSynthesisTableDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SimulationGetQuantitiesRequest} [simulationGetQuantitiesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetLoadQuantitiesPost(simulationGetQuantitiesRequest, options) {
            return localVarFp.apiSimulationsGetLoadQuantitiesPost(simulationGetQuantitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsGetSectorWLoadFormula(options) {
            return localVarFp.apiSimulationsGetSectorWLoadFormula(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {HasSectorWLoadAndFormulaRequest} [hasSectorWLoadAndFormulaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsHasSectorWLoadAndFormula(hasSectorWLoadAndFormulaRequest, options) {
            return localVarFp.apiSimulationsHasSectorWLoadAndFormula(hasSectorWLoadAndFormulaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SimulationsLoadTableGetRequest} [simulationsLoadTableGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsLoadTableSsePost(simulationsLoadTableGetRequest, options) {
            return localVarFp.apiSimulationsLoadTableSsePost(simulationsLoadTableGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsDailyLoadsGetRequest} [simulationsDailyLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdDailyLoadsPost(simulationId, simulationsDailyLoadsGetRequest, options) {
            return localVarFp.apiSimulationsSimulationIdDailyLoadsPost(simulationId, simulationsDailyLoadsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsDisabledEventsGetRequest} [simulationsDisabledEventsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdDisabledEventsPost(simulationId, simulationsDisabledEventsGetRequest, options) {
            return localVarFp.apiSimulationsSimulationIdDisabledEventsPost(simulationId, simulationsDisabledEventsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationEventFieldsGetRequest} [simulationEventFieldsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdEventFieldsPost(simulationId, simulationEventFieldsGetRequest, options) {
            return localVarFp.apiSimulationsSimulationIdEventFieldsPost(simulationId, simulationEventFieldsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsEventsInfosGetRequest} [simulationsEventsInfosGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdEventsInfosPost(simulationId, simulationsEventsInfosGetRequest, options) {
            return localVarFp.apiSimulationsSimulationIdEventsInfosPost(simulationId, simulationsEventsInfosGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsImportsGetRequest} [simulationsImportsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdImportsPost(simulationId, simulationsImportsGetRequest, options) {
            return localVarFp.apiSimulationsSimulationIdImportsPost(simulationId, simulationsImportsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsLoadGraphGetRequest} [simulationsLoadGraphGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadGraphPost(simulationId, simulationsLoadGraphGetRequest, options) {
            return localVarFp.apiSimulationsSimulationIdLoadGraphPost(simulationId, simulationsLoadGraphGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsLoadsFullGetRequest} [simulationsLoadsFullGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadsFullPost(simulationId, simulationsLoadsFullGetRequest, options) {
            return localVarFp.apiSimulationsSimulationIdLoadsFullPost(simulationId, simulationsLoadsFullGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsLoadsGetRequest} [simulationsLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadsPost(simulationId, simulationsLoadsGetRequest, options) {
            return localVarFp.apiSimulationsSimulationIdLoadsPost(simulationId, simulationsLoadsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationsRawLoadsGetRequest} [simulationsRawLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdLoadsRawPost(simulationId, simulationsRawLoadsGetRequest, options) {
            return localVarFp.apiSimulationsSimulationIdLoadsRawPost(simulationId, simulationsRawLoadsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdOfsLastDoneDatePost(simulationId, body, options) {
            return localVarFp.apiSimulationsSimulationIdOfsLastDoneDatePost(simulationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdOfsPost(simulationId, options) {
            return localVarFp.apiSimulationsSimulationIdOfsPost(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdOpsPost(simulationId, options) {
            return localVarFp.apiSimulationsSimulationIdOpsPost(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {SimulationSectorsLoadsGetRequest} [simulationSectorsLoadsGetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsSimulationIdSectorsLoadsPost(simulationId, simulationSectorsLoadsGetRequest, options) {
            return localVarFp.apiSimulationsSimulationIdSectorsLoadsPost(simulationId, simulationSectorsLoadsGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SimulationUpdateFromSchedulingRequest} [simulationUpdateFromSchedulingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSimulationsUpdateLoadFromSchedulingPost(simulationUpdateFromSchedulingRequest, options) {
            return localVarFp.apiSimulationsUpdateLoadFromSchedulingPost(simulationUpdateFromSchedulingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSpecificSaintGobainSullyLastUpdatesGet(options) {
            return localVarFp.apiSpecificSaintGobainSullyLastUpdatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdjustProdObjectiveRequest} [adjustProdObjectiveRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksAdjustProdObjectivePost(adjustProdObjectiveRequest, options) {
            return localVarFp.apiStocksAdjustProdObjectivePost(adjustProdObjectiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {StocksGetDemandRequest} [stocksGetDemandRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksGetDemandPost(stocksGetDemandRequest, options) {
            return localVarFp.apiStocksGetDemandPost(stocksGetDemandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {StocksGetOverloadedSectorsByArticlesRequest} [stocksGetOverloadedSectorsByArticlesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksGetOverloadedSectorsByArticlesPost(stocksGetOverloadedSectorsByArticlesRequest, options) {
            return localVarFp.apiStocksGetOverloadedSectorsByArticlesPost(stocksGetOverloadedSectorsByArticlesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {StocksSetDemandRequest} [stocksSetDemandRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStocksSetDemandPost(stocksSetDemandRequest, options) {
            return localVarFp.apiStocksSetDemandPost(stocksSetDemandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTasksPost(options) {
            return localVarFp.apiTasksPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersCheckLastLoginPost(options) {
            return localVarFp.apiUsersCheckLastLoginPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersFlushCacheGet(options) {
            return localVarFp.apiUsersFlushCacheGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUpdateFromFirebasePost(options) {
            return localVarFp.apiUsersUpdateFromFirebasePost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ValidatePasswordExpirationRouteRequest} [validatePasswordExpirationRouteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authValidatePasswordExpirationPost(validatePasswordExpirationRouteRequest, options) {
            return localVarFp.authValidatePasswordExpirationPost(validatePasswordExpirationRouteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BalanceLoadToCapacityRequest} [balanceLoadToCapacityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceLoadToCapacity(balanceLoadToCapacityRequest, options) {
            return localVarFp.balanceLoadToCapacity(balanceLoadToCapacityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bigqueryGetPost(options) {
            return localVarFp.bigqueryGetPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProdObjectiveTransferRequest} [prodObjectiveTransferRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProdObjectiveTransfer(prodObjectiveTransferRequest, options) {
            return localVarFp.createProdObjectiveTransfer(prodObjectiveTransferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DailyCapacityAndTotalCapacityByDateRequest} [dailyCapacityAndTotalCapacityByDateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyCapacityAndTotalCapacityByDate(dailyCapacityAndTotalCapacityByDateRequest, options) {
            return localVarFp.getDailyCapacityAndTotalCapacityByDate(dailyCapacityAndTotalCapacityByDateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} opId
         * @param {string} simulationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestLoadEventsRowsByOpId(opId, simulationId, options) {
            return localVarFp.getLatestLoadEventsRowsByOpId(opId, simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LoadRateAndRemainingCapacityRequest} [loadRateAndRemainingCapacityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadRateAndRemainingCapacity(loadRateAndRemainingCapacityRequest, options) {
            return localVarFp.getLoadRateAndRemainingCapacity(loadRateAndRemainingCapacityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {SchedulingGetAnalyticsRequest} [schedulingGetAnalyticsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingAnalytics(simulationId, schedulingGetAnalyticsRequest, options) {
            return localVarFp.getSchedulingAnalytics(simulationId, schedulingGetAnalyticsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingComponentsGetComponentAnalyticsRequest} [schedulingComponentsGetComponentAnalyticsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentAnalytics(schedulingComponentsGetComponentAnalyticsRequest, options) {
            return localVarFp.getSchedulingComponentsComponentAnalytics(schedulingComponentsGetComponentAnalyticsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingComponentsGetComponentDetailsRequest} [schedulingComponentsGetComponentDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentDetails(schedulingComponentsGetComponentDetailsRequest, options) {
            return localVarFp.getSchedulingComponentsComponentDetails(schedulingComponentsGetComponentDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingComponentsGetComponentInitialStockRequest} [schedulingComponentsGetComponentInitialStockRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentInitialStock(schedulingComponentsGetComponentInitialStockRequest, options) {
            return localVarFp.getSchedulingComponentsComponentInitialStock(schedulingComponentsGetComponentInitialStockRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingComponentsGetComponentsCurrentStocksRequest} [schedulingComponentsGetComponentsCurrentStocksRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsComponentsCurrentStocks(schedulingComponentsGetComponentsCurrentStocksRequest, options) {
            return localVarFp.getSchedulingComponentsComponentsCurrentStocks(schedulingComponentsGetComponentsCurrentStocksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SchedulingComponentsGetSidebarComponentsDetailsRequest} [schedulingComponentsGetSidebarComponentsDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulingComponentsSidebarComponentsDetails(schedulingComponentsGetSidebarComponentsDetailsRequest, options) {
            return localVarFp.getSchedulingComponentsSidebarComponentsDetails(schedulingComponentsGetSidebarComponentsDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} simulationId
         * @param {string} ofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationsOfsParams(simulationId, ofId, options) {
            return localVarFp.getSimulationsOfsParams(simulationId, ofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {StocksGetDemandByArticlesRequest} [stocksGetDemandByArticlesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksDemandByArticles(stocksGetDemandByArticlesRequest, options) {
            return localVarFp.getStocksDemandByArticles(stocksGetDemandByArticlesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {StocksGetObjectiveByArticlesRequest} [stocksGetObjectiveByArticlesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksObjectiveByArticles(stocksGetObjectiveByArticlesRequest, options) {
            return localVarFp.getStocksObjectiveByArticles(stocksGetObjectiveByArticlesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksSectorsIdsFromGammes(options) {
            return localVarFp.getStocksSectorsIdsFromGammes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {StocksGetStocksTableRequest} [stocksGetStocksTableRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksTable(stocksGetStocksTableRequest, options) {
            return localVarFp.getStocksTable(stocksGetStocksTableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFilePost(options) {
            return localVarFp.importFilePost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowsPost(options) {
            return localVarFp.importRowsPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importSignedUrlGet(options) {
            return localVarFp.importSignedUrlGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importUpdateDataB2bPost(options) {
            return localVarFp.importUpdateDataB2bPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importUpdateDataPost(options) {
            return localVarFp.importUpdateDataPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyOnOplitDateParametersUpdate(options) {
            return localVarFp.notifyOnOplitDateParametersUpdate(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pgParserPost(options) {
            return localVarFp.pgParserPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOPsUpdatesToSGS(options) {
            return localVarFp.sendOPsUpdatesToSGS(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MicrosoftRoleSyncRouteRequest} [microsoftRoleSyncRouteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMicrosoftRoles(microsoftRoleSyncRouteRequest, options) {
            return localVarFp.syncMicrosoftRoles(microsoftRoleSyncRouteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SyncOIDCUserRouteRequest} [syncOIDCUserRouteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOIDCUser(syncOIDCUserRouteRequest, options) {
            return localVarFp.syncOIDCUser(syncOIDCUserRouteRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends BaseAPI {
    /**
     *
     * @param {any} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAdminHackyDevFnsPost(body, options) {
        return DefaultApiFp(this.configuration).apiAdminHackyDevFnsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAdminInfraCostsByClientGet(options) {
        return DefaultApiFp(this.configuration).apiAdminInfraCostsByClientGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GetCrossingTimesByArticleRequest} [getCrossingTimesByArticleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAnalyticsCrossingTimesByArticlePost(getCrossingTimesByArticleRequest, options) {
        return DefaultApiFp(this.configuration).apiAnalyticsCrossingTimesByArticlePost(getCrossingTimesByArticleRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAnalyticsCrossingTimesPost(body, options) {
        return DefaultApiFp(this.configuration).apiAnalyticsCrossingTimesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AnalyticsOfsEndTimeRequest} [analyticsOfsEndTimeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAnalyticsEndTimePost(analyticsOfsEndTimeRequest, options) {
        return DefaultApiFp(this.configuration).apiAnalyticsEndTimePost(analyticsOfsEndTimeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AnalyticsFiltersRequest} [analyticsFiltersRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAnalyticsFiltersPost(analyticsFiltersRequest, options) {
        return DefaultApiFp(this.configuration).apiAnalyticsFiltersPost(analyticsFiltersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GetOPsByOFRequest} [getOPsByOFRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAnalyticsGetOpsByOfPost(getOPsByOFRequest, options) {
        return DefaultApiFp(this.configuration).apiAnalyticsGetOpsByOfPost(getOPsByOFRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AnalyticsOFRequest} [analyticsOFRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAnalyticsOfsPost(analyticsOFRequest, options) {
        return DefaultApiFp(this.configuration).apiAnalyticsOfsPost(analyticsOFRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AnalyticsProgressRequest} [analyticsProgressRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAnalyticsProgressPost(analyticsProgressRequest, options) {
        return DefaultApiFp(this.configuration).apiAnalyticsProgressPost(analyticsProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AnalyticsStagnationRequest} [analyticsStagnationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAnalyticsStagnationPost(analyticsStagnationRequest, options) {
        return DefaultApiFp(this.configuration).apiAnalyticsStagnationPost(analyticsStagnationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AnalyticsOfsStartedOnTimeRequest} [analyticsOfsStartedOnTimeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAnalyticsStartedOnTimePost(analyticsOfsStartedOnTimeRequest, options) {
        return DefaultApiFp(this.configuration).apiAnalyticsStartedOnTimePost(analyticsOfsStartedOnTimeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AnalyticsWIPRequest} [analyticsWIPRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiAnalyticsWipPost(analyticsWIPRequest, options) {
        return DefaultApiFp(this.configuration).apiAnalyticsWipPost(analyticsWIPRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RecoverImportPostRequest} [recoverImportPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiArchivesRecoverImportPost(recoverImportPostRequest, options) {
        return DefaultApiFp(this.configuration).apiArchivesRecoverImportPost(recoverImportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RecoverSimulationPostRequest} [recoverSimulationPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiArchivesRecoverSimulationPost(recoverSimulationPostRequest, options) {
        return DefaultApiFp(this.configuration).apiArchivesRecoverSimulationPost(recoverSimulationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ArticlesGetRequest} [articlesGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiArticlePost(articlesGetRequest, options) {
        return DefaultApiFp(this.configuration).apiArticlePost(articlesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ArticlesGetRequest} [articlesGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiArticleTargetStockPost(articlesGetRequest, options) {
        return DefaultApiFp(this.configuration).apiArticleTargetStockPost(articlesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GetWorkdaysPostRequest} [getWorkdaysPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCalendarGetWorkdaysPost(getWorkdaysPostRequest, options) {
        return DefaultApiFp(this.configuration).apiCalendarGetWorkdaysPost(getWorkdaysPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SaveCalendarRequest} [saveCalendarRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCalendarSaveCalendarPost(saveCalendarRequest, options) {
        return DefaultApiFp(this.configuration).apiCalendarSaveCalendarPost(saveCalendarRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCalendarTestPost(body, options) {
        return DefaultApiFp(this.configuration).apiCalendarTestPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CalculateCapaRequest} [calculateCapaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCapacitiesCalculateCapaPost(calculateCapaRequest, options) {
        return DefaultApiFp(this.configuration).apiCapacitiesCalculateCapaPost(calculateCapaRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DailyCapacityRequest} [dailyCapacityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCapacitiesDailyPost(dailyCapacityRequest, options) {
        return DefaultApiFp(this.configuration).apiCapacitiesDailyPost(dailyCapacityRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DailyTotalCapaRequest} [dailyTotalCapaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCapacitiesDailyTotalCapaPost(dailyTotalCapaRequest, options) {
        return DefaultApiFp(this.configuration).apiCapacitiesDailyTotalCapaPost(dailyTotalCapaRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FullTimeNeedRequest} [fullTimeNeedRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCapacitiesFullTimeNeedPost(fullTimeNeedRequest, options) {
        return DefaultApiFp(this.configuration).apiCapacitiesFullTimeNeedPost(fullTimeNeedRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NeededOrgaRequest} [neededOrgaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCapacitiesNeededOrgaPost(neededOrgaRequest, options) {
        return DefaultApiFp(this.configuration).apiCapacitiesNeededOrgaPost(neededOrgaRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OverloadedSectorsRequest} [overloadedSectorsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCapacitiesOverloadedSectorsPost(overloadedSectorsRequest, options) {
        return DefaultApiFp(this.configuration).apiCapacitiesOverloadedSectorsPost(overloadedSectorsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TotalCapaRequest} [totalCapaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCapacitiesTotalCapaPost(totalCapaRequest, options) {
        return DefaultApiFp(this.configuration).apiCapacitiesTotalCapaPost(totalCapaRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TotalRemainingCapaRequest} [totalRemainingCapaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCapacitiesTotalRemainingCapaPost(totalRemainingCapaRequest, options) {
        return DefaultApiFp(this.configuration).apiCapacitiesTotalRemainingCapaPost(totalRemainingCapaRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClientsCreateRequest} [clientsCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiClientsPost(clientsCreateRequest, options) {
        return DefaultApiFp(this.configuration).apiClientsPost(clientsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CrispHasNewProductReleaseRequest} [crispHasNewProductReleaseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsCrispHasNewProductReleasePost(crispHasNewProductReleaseRequest, options) {
        return DefaultApiFp(this.configuration).apiConnectorsCrispHasNewProductReleasePost(crispHasNewProductReleaseRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsCrispWebhooksPost(options) {
        return DefaultApiFp(this.configuration).apiConnectorsCrispWebhooksPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CapaBySectorRequest} [capaBySectorRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsExternalCapaBySectorPost(capaBySectorRequest, options) {
        return DefaultApiFp(this.configuration).apiConnectorsExternalCapaBySectorPost(capaBySectorRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsExternalSectorsGet(options) {
        return DefaultApiFp(this.configuration).apiConnectorsExternalSectorsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AddCyclePostRequest} [addCyclePostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsLinearAddCyclePost(addCyclePostRequest, options) {
        return DefaultApiFp(this.configuration).apiConnectorsLinearAddCyclePost(addCyclePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsLinearListCyclesPost(body, options) {
        return DefaultApiFp(this.configuration).apiConnectorsLinearListCyclesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CycleIdRequest} [cycleIdRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsLinearLoadCycleDataPost(cycleIdRequest, options) {
        return DefaultApiFp(this.configuration).apiConnectorsLinearLoadCycleDataPost(cycleIdRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SupportDateRangeRequest} [supportDateRangeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsLinearLoadSupportDataPost(supportDateRangeRequest, options) {
        return DefaultApiFp(this.configuration).apiConnectorsLinearLoadSupportDataPost(supportDateRangeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SaveTeamDataPointRequest} [saveTeamDataPointRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsLinearSaveTeamDataPointPost(saveTeamDataPointRequest, options) {
        return DefaultApiFp(this.configuration).apiConnectorsLinearSaveTeamDataPointPost(saveTeamDataPointRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LinearTechKPIsPostRequest} [linearTechKPIsPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsLinearTechKpisPost(linearTechKPIsPostRequest, options) {
        return DefaultApiFp(this.configuration).apiConnectorsLinearTechKpisPost(linearTechKPIsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsLinearTimeCalculatorPost(body, options) {
        return DefaultApiFp(this.configuration).apiConnectorsLinearTimeCalculatorPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsLinearUpdateLabelsPost(options) {
        return DefaultApiFp(this.configuration).apiConnectorsLinearUpdateLabelsPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsLinearWebhooksPost(options) {
        return DefaultApiFp(this.configuration).apiConnectorsLinearWebhooksPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {M3ExtractionRequest} [m3ExtractionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiConnectorsM3ExtractDataPost(m3ExtractionRequest, options) {
        return DefaultApiFp(this.configuration).apiConnectorsM3ExtractDataPost(m3ExtractionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCustomerInterfaceGetCustomersDetailsGet(options) {
        return DefaultApiFp(this.configuration).apiCustomerInterfaceGetCustomersDetailsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCustomerInterfaceGetFiltersGet(options) {
        return DefaultApiFp(this.configuration).apiCustomerInterfaceGetFiltersGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CustomerInterfaceGetOfsDetailsRequest} [customerInterfaceGetOfsDetailsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCustomerInterfaceGetOfsDetailsPost(customerInterfaceGetOfsDetailsRequest, options) {
        return DefaultApiFp(this.configuration).apiCustomerInterfaceGetOfsDetailsPost(customerInterfaceGetOfsDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCustomerInterfaceGetProviderIdsGet(options) {
        return DefaultApiFp(this.configuration).apiCustomerInterfaceGetProviderIdsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CustomerInterfaceListOfsGetRequest} [customerInterfaceListOfsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiCustomerInterfaceListOfsPost(customerInterfaceListOfsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiCustomerInterfaceListOfsPost(customerInterfaceListOfsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DailyDelaysGetRequest} [dailyDelaysGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiDailyDelaysPost(dailyDelaysGetRequest, options) {
        return DefaultApiFp(this.configuration).apiDailyDelaysPost(dailyDelaysGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DelaysBySectorGetRequest} [delaysBySectorGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiDelaysPost(delaysBySectorGetRequest, options) {
        return DefaultApiFp(this.configuration).apiDelaysPost(delaysBySectorGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EventsGetRequest} [eventsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiEventsDetailsPost(eventsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiEventsDetailsPost(eventsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EventsFieldsGetRequest} [eventsFieldsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiEventsFieldsPost(eventsFieldsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiEventsFieldsPost(eventsFieldsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EventsGetSimpleEventsPostRequest} [eventsGetSimpleEventsPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiEventsGetSimpleEventsPost(eventsGetSimpleEventsPostRequest, options) {
        return DefaultApiFp(this.configuration).apiEventsGetSimpleEventsPost(eventsGetSimpleEventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EventsMigratePostRequest} [eventsMigratePostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiEventsMigratePost(eventsMigratePostRequest, options) {
        return DefaultApiFp(this.configuration).apiEventsMigratePost(eventsMigratePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiEventsOnChangePost(options) {
        return DefaultApiFp(this.configuration).apiEventsOnChangePost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiEventsOnChangeSsePost(options) {
        return DefaultApiFp(this.configuration).apiEventsOnChangeSsePost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {any | Array<any>} [anyArrayany]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiEventsPushPost(anyArrayany, options) {
        return DefaultApiFp(this.configuration).apiEventsPushPost(anyArrayany, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiFabriqCheckConnectionGet(options) {
        return DefaultApiFp(this.configuration).apiFabriqCheckConnectionGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} ticketId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiFabriqCreateTicketTicketIdPost(ticketId, options) {
        return DefaultApiFp(this.configuration).apiFabriqCreateTicketTicketIdPost(ticketId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} ticketId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiFabriqDeleteTicketTicketIdPost(ticketId, options) {
        return DefaultApiFp(this.configuration).apiFabriqDeleteTicketTicketIdPost(ticketId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} ticketId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiFabriqGetTicketTicketIdGet(ticketId, options) {
        return DefaultApiFp(this.configuration).apiFabriqGetTicketTicketIdGet(ticketId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiFabriqGetUsersGet(options) {
        return DefaultApiFp(this.configuration).apiFabriqGetUsersGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GammesGetRequest} [gammesGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiGammesPost(gammesGetRequest, options) {
        return DefaultApiFp(this.configuration).apiGammesPost(gammesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GetDownloadURLRequest} [getDownloadURLRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiGetDownloadUrlPost(getDownloadURLRequest, options) {
        return DefaultApiFp(this.configuration).apiGetDownloadUrlPost(getDownloadURLRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ImportsDetailedInitialStocksRequest} [importsDetailedInitialStocksRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsDetailedInitialStocksPost(importsDetailedInitialStocksRequest, options) {
        return DefaultApiFp(this.configuration).apiImportsDetailedInitialStocksPost(importsDetailedInitialStocksRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ImportErrorLogsRequestBody} [importErrorLogsRequestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsErrorLogsPost(importErrorLogsRequestBody, options) {
        return DefaultApiFp(this.configuration).apiImportsErrorLogsPost(importErrorLogsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ImportsFieldsKeysGetRequest} [importsFieldsKeysGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsFieldsKeysPost(importsFieldsKeysGetRequest, options) {
        return DefaultApiFp(this.configuration).apiImportsFieldsKeysPost(importsFieldsKeysGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ImportsGenerateFileRequest} [importsGenerateFileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsGenerateImportFilePost(importsGenerateFileRequest, options) {
        return DefaultApiFp(this.configuration).apiImportsGenerateImportFilePost(importsGenerateFileRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GetImportUnitsRequest} [getImportUnitsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsGetImportUnitsPost(getImportUnitsRequest, options) {
        return DefaultApiFp(this.configuration).apiImportsGetImportUnitsPost(getImportUnitsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} importId
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsImportIdArticlesRefsPost(importId, body, options) {
        return DefaultApiFp(this.configuration).apiImportsImportIdArticlesRefsPost(importId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} importId
     * @param {ImportsDailyRawLoadsGetRequest} [importsDailyRawLoadsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsImportIdDailyRawLoadsPost(importId, importsDailyRawLoadsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiImportsImportIdDailyRawLoadsPost(importId, importsDailyRawLoadsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} importId
     * @param {ImportsSpecificLoadsGetRequest} [importsSpecificLoadsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsImportIdLoadsPost(importId, importsSpecificLoadsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiImportsImportIdLoadsPost(importId, importsSpecificLoadsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} importId
     * @param {string} ofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsImportIdOfsOfIdLastDateGet(importId, ofId, options) {
        return DefaultApiFp(this.configuration).apiImportsImportIdOfsOfIdLastDateGet(importId, ofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ImportLogsRequestBody} [importLogsRequestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsImportLogsPost(importLogsRequestBody, options) {
        return DefaultApiFp(this.configuration).apiImportsImportLogsPost(importLogsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ImportsInitialStocksRequest} [importsInitialStocksRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsInitialStocksPost(importsInitialStocksRequest, options) {
        return DefaultApiFp(this.configuration).apiImportsInitialStocksPost(importsInitialStocksRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ImportsLastRequest} [importsLastRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsLastPost(importsLastRequest, options) {
        return DefaultApiFp(this.configuration).apiImportsLastPost(importsLastRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ImportsLateRequest} [importsLateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsLatePost(importsLateRequest, options) {
        return DefaultApiFp(this.configuration).apiImportsLatePost(importsLateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ImportsLoadsGetRequest} [importsLoadsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsLoadsPost(importsLoadsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiImportsLoadsPost(importsLoadsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ImportsSkippedRequest} [importsSkippedRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiImportsSkippedPost(importsSkippedRequest, options) {
        return DefaultApiFp(this.configuration).apiImportsSkippedPost(importsSkippedRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LaunchPgMigrateRequest} [launchPgMigrateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiLaunchPgMigratePost(launchPgMigrateRequest, options) {
        return DefaultApiFp(this.configuration).apiLaunchPgMigratePost(launchPgMigrateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiMercateamGetAbsencesGet(options) {
        return DefaultApiFp(this.configuration).apiMercateamGetAbsencesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiMercateamGetEmployeesListGet(options) {
        return DefaultApiFp(this.configuration).apiMercateamGetEmployeesListGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiMercateamGetPlanningsGet(options) {
        return DefaultApiFp(this.configuration).apiMercateamGetPlanningsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiMercateamGetSectorsPost(options) {
        return DefaultApiFp(this.configuration).apiMercateamGetSectorsPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiMercateamGetStatusGet(options) {
        return DefaultApiFp(this.configuration).apiMercateamGetStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiMercateamSavePlanningsPost(options) {
        return DefaultApiFp(this.configuration).apiMercateamSavePlanningsPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiMercateamSaveUnexpectedEventsPost(options) {
        return DefaultApiFp(this.configuration).apiMercateamSaveUnexpectedEventsPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DbHelperProxyPostRequest} [dbHelperProxyPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiMigrationDbhelperProxyPost(dbHelperProxyPostRequest, options) {
        return DefaultApiFp(this.configuration).apiMigrationDbhelperProxyPost(dbHelperProxyPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MigrateToTargetPostRequest} [migrateToTargetPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiMigrationMigrateToTargetPost(migrateToTargetPostRequest, options) {
        return DefaultApiFp(this.configuration).apiMigrationMigrateToTargetPost(migrateToTargetPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PGProxyPostRequest} [pGProxyPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiMigrationPgProxyPost(pGProxyPostRequest, options) {
        return DefaultApiFp(this.configuration).apiMigrationPgProxyPost(pGProxyPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiNomenclaturesGetAllGet(options) {
        return DefaultApiFp(this.configuration).apiNomenclaturesGetAllGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NomenclaturesPostRequestUpdate} [nomenclaturesPostRequestUpdate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiNomenclaturesUpdatePost(nomenclaturesPostRequestUpdate, options) {
        return DefaultApiFp(this.configuration).apiNomenclaturesUpdatePost(nomenclaturesPostRequestUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OplitCopilotTriggerCopilotReschedulingPostRequest} [oplitCopilotTriggerCopilotReschedulingPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiOplitCopilotTriggerCopilotRescheduling(oplitCopilotTriggerCopilotReschedulingPostRequest, options) {
        return DefaultApiFp(this.configuration).apiOplitCopilotTriggerCopilotRescheduling(oplitCopilotTriggerCopilotReschedulingPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OplitDateGetCsvWithOplitDatePostRequest} [oplitDateGetCsvWithOplitDatePostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiOplitDateGenerateCSVDoneOFsHistory(oplitDateGetCsvWithOplitDatePostRequest, options) {
        return DefaultApiFp(this.configuration).apiOplitDateGenerateCSVDoneOFsHistory(oplitDateGetCsvWithOplitDatePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OplitDateGetCsvWithOplitDatePostRequest} [oplitDateGetCsvWithOplitDatePostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiOplitDateGenerateCSVOngoingOFsEstimations(oplitDateGetCsvWithOplitDatePostRequest, options) {
        return DefaultApiFp(this.configuration).apiOplitDateGenerateCSVOngoingOFsEstimations(oplitDateGetCsvWithOplitDatePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiOplitDateGetClientFeatures(options) {
        return DefaultApiFp(this.configuration).apiOplitDateGetClientFeatures(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiOplitDateGetClientOFs(options) {
        return DefaultApiFp(this.configuration).apiOplitDateGetClientOFs(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiOplitDateGetClientTeamSettings(options) {
        return DefaultApiFp(this.configuration).apiOplitDateGetClientTeamSettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OplitDateGetCsvWithOfHistoryPostRequest} [oplitDateGetCsvWithOfHistoryPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiOplitDateGetCsvWithOfHistory(oplitDateGetCsvWithOfHistoryPostRequest, options) {
        return DefaultApiFp(this.configuration).apiOplitDateGetCsvWithOfHistory(oplitDateGetCsvWithOfHistoryPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiOplitDateGetImpactedScopes(options) {
        return DefaultApiFp(this.configuration).apiOplitDateGetImpactedScopes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiOplitDateGetLastUpdate(options) {
        return DefaultApiFp(this.configuration).apiOplitDateGetLastUpdate(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OplitDateSaveClientFeaturesPostRequest} [oplitDateSaveClientFeaturesPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiOplitDateSaveClientFeatures(oplitDateSaveClientFeaturesPostRequest, options) {
        return DefaultApiFp(this.configuration).apiOplitDateSaveClientFeatures(oplitDateSaveClientFeaturesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OplitDateSaveOplitDateTeamSettingsPostRequest} [oplitDateSaveOplitDateTeamSettingsPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiOplitDateSaveOplitDateTeamSettings(oplitDateSaveOplitDateTeamSettingsPostRequest, options) {
        return DefaultApiFp(this.configuration).apiOplitDateSaveOplitDateTeamSettings(oplitDateSaveOplitDateTeamSettingsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PdpLoadGetInitialLoadsRequest} [pdpLoadGetInitialLoadsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPdpLoadGetInitialLoadsPost(pdpLoadGetInitialLoadsRequest, options) {
        return DefaultApiFp(this.configuration).apiPdpLoadGetInitialLoadsPost(pdpLoadGetInitialLoadsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PdpLoadGetLoadEventsRequest} [pdpLoadGetLoadEventsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPdpLoadGetLoadEventsPost(pdpLoadGetLoadEventsRequest, options) {
        return DefaultApiFp(this.configuration).apiPdpLoadGetLoadEventsPost(pdpLoadGetLoadEventsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PdpLoadGetSectorChargePostRequest} [pdpLoadGetSectorChargePostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPdpLoadGetSectorChargePost(pdpLoadGetSectorChargePostRequest, options) {
        return DefaultApiFp(this.configuration).apiPdpLoadGetSectorChargePost(pdpLoadGetSectorChargePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPdpLoadHasSectorChargeFormulaGet(options) {
        return DefaultApiFp(this.configuration).apiPdpLoadHasSectorChargeFormulaGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PdpLoadSaveLoadEventRequest} [pdpLoadSaveLoadEventRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPdpLoadSaveLoadEventPost(pdpLoadSaveLoadEventRequest, options) {
        return DefaultApiFp(this.configuration).apiPdpLoadSaveLoadEventPost(pdpLoadSaveLoadEventRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PdpLoadUpdateLoadEventRequest} [pdpLoadUpdateLoadEventRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPdpLoadUpdateLoadEventPost(pdpLoadUpdateLoadEventRequest, options) {
        return DefaultApiFp(this.configuration).apiPdpLoadUpdateLoadEventPost(pdpLoadUpdateLoadEventRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PgTriggersPostRequest} [pgTriggersPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPgTriggersPost(pgTriggersPostRequest, options) {
        return DefaultApiFp(this.configuration).apiPgTriggersPost(pgTriggersPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AbsencesByOperatorRequest} [absencesByOperatorRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPlanningAbsencesByOperatorPost(absencesByOperatorRequest, options) {
        return DefaultApiFp(this.configuration).apiPlanningAbsencesByOperatorPost(absencesByOperatorRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DailyPlanningRequest} [dailyPlanningRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPlanningDailyPlanningPost(dailyPlanningRequest, options) {
        return DefaultApiFp(this.configuration).apiPlanningDailyPlanningPost(dailyPlanningRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {IsGoulotRequest} [isGoulotRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPlanningIsGoulotPost(isGoulotRequest, options) {
        return DefaultApiFp(this.configuration).apiPlanningIsGoulotPost(isGoulotRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MachinesByOperatorRequest} [machinesByOperatorRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPlanningMachinesByOperatorPost(machinesByOperatorRequest, options) {
        return DefaultApiFp(this.configuration).apiPlanningMachinesByOperatorPost(machinesByOperatorRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MachinesBySectorRequest} [machinesBySectorRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPlanningMachinesBySectorPost(machinesBySectorRequest, options) {
        return DefaultApiFp(this.configuration).apiPlanningMachinesBySectorPost(machinesBySectorRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CustomMSDFieldValueRequest} [customMSDFieldValueRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPlanningMsdFieldValuePost(customMSDFieldValueRequest, options) {
        return DefaultApiFp(this.configuration).apiPlanningMsdFieldValuePost(customMSDFieldValueRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OperatorsByMachineRequest} [operatorsByMachineRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPlanningOperatorsByMachinePost(operatorsByMachineRequest, options) {
        return DefaultApiFp(this.configuration).apiPlanningOperatorsByMachinePost(operatorsByMachineRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OperatorsBySectorRequest} [operatorsBySectorRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPlanningOperatorsBySectorPost(operatorsBySectorRequest, options) {
        return DefaultApiFp(this.configuration).apiPlanningOperatorsBySectorPost(operatorsBySectorRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PeriodesOrgaRequest} [periodesOrgaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPlanningPeriodesOrgaPost(periodesOrgaRequest, options) {
        return DefaultApiFp(this.configuration).apiPlanningPeriodesOrgaPost(periodesOrgaRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SaveStandardPlanningRequest} [saveStandardPlanningRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPlanningSaveStandardPlanningPost(saveStandardPlanningRequest, options) {
        return DefaultApiFp(this.configuration).apiPlanningSaveStandardPlanningPost(saveStandardPlanningRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductionsAllGetRequest} [productionsAllGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiProductionsAllPost(productionsAllGetRequest, options) {
        return DefaultApiFp(this.configuration).apiProductionsAllPost(productionsAllGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductionsLastProdUpdateGetRequest} [productionsLastProdUpdateGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiProductionsLastProdUpdatePost(productionsLastProdUpdateGetRequest, options) {
        return DefaultApiFp(this.configuration).apiProductionsLastProdUpdatePost(productionsLastProdUpdateGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiPubsubPost(options) {
        return DefaultApiFp(this.configuration).apiPubsubPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingAiPost(options) {
        return DefaultApiFp(this.configuration).apiSchedulingAiPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingCancelLastSchedulingAIRequest} [schedulingCancelLastSchedulingAIRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingCancelLastReschedulingAiPost(schedulingCancelLastSchedulingAIRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingCancelLastReschedulingAiPost(schedulingCancelLastSchedulingAIRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingGetConwipTicketsGaugesPostRequest} [schedulingGetConwipTicketsGaugesPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingGetConwipTicketsGaugesPost(schedulingGetConwipTicketsGaugesPostRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingGetConwipTicketsGaugesPost(schedulingGetConwipTicketsGaugesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingGetNextAvailableCapaDayRequest} [schedulingGetNextAvailableCapaDayRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingGetNextAvailableCapaDayPost(schedulingGetNextAvailableCapaDayRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingGetNextAvailableCapaDayPost(schedulingGetNextAvailableCapaDayRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingGetOFUpdateDateRequest} [schedulingGetOFUpdateDateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingGetOFUpdateDate(schedulingGetOFUpdateDateRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingGetOFUpdateDate(schedulingGetOFUpdateDateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingGetOfsFiltersRequest} [schedulingGetOfsFiltersRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingGetOfsFiltersPost(schedulingGetOfsFiltersRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingGetOfsFiltersPost(schedulingGetOfsFiltersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingGetParametersOfDisplayGet(options) {
        return DefaultApiFp(this.configuration).apiSchedulingGetParametersOfDisplayGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingGetQuantiteOFRequest} [schedulingGetQuantiteOFRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingGetQuantiteOfPost(schedulingGetQuantiteOFRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingGetQuantiteOfPost(schedulingGetQuantiteOFRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingGetReschedulingLogsRequest} [schedulingGetReschedulingLogsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingGetReschedulingLogsPost(schedulingGetReschedulingLogsRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingGetReschedulingLogsPost(schedulingGetReschedulingLogsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingGetSimulationLastImportDataRequest} [schedulingGetSimulationLastImportDataRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingGetSimulationLastImportData(schedulingGetSimulationLastImportDataRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingGetSimulationLastImportData(schedulingGetSimulationLastImportDataRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingGetSubOFsRequest} [schedulingGetSubOFsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingGetSubOfsPost(schedulingGetSubOFsRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingGetSubOfsPost(schedulingGetSubOFsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingListOfsGetRequest} [schedulingListOfsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingListOfsPost(schedulingListOfsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingListOfsPost(schedulingListOfsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingMachineCentersPost(options) {
        return DefaultApiFp(this.configuration).apiSchedulingMachineCentersPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingProductionOrdersLeadTimesPost(options) {
        return DefaultApiFp(this.configuration).apiSchedulingProductionOrdersLeadTimesPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SaveRealtimeSchedulingEventsPostRequest} [saveRealtimeSchedulingEventsPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingSaveRealtimeSchedulingEventsPost(saveRealtimeSchedulingEventsPostRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingSaveRealtimeSchedulingEventsPost(saveRealtimeSchedulingEventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SaveSchedulingEventsPostRequest} [saveSchedulingEventsPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingSaveSchedulingEventsPost(saveSchedulingEventsPostRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingSaveSchedulingEventsPost(saveSchedulingEventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingSseProductionOrdersPost(options) {
        return DefaultApiFp(this.configuration).apiSchedulingSseProductionOrdersPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UpdateCapacityFromSimulationPostRequest} [updateCapacityFromSimulationPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingUpdateCapacityFromSimulationPost(updateCapacityFromSimulationPostRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingUpdateCapacityFromSimulationPost(updateCapacityFromSimulationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingUpdateConwipTicketsGaugesPostRequest} [schedulingUpdateConwipTicketsGaugesPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSchedulingUpdateConwipTicketsGaugesPost(schedulingUpdateConwipTicketsGaugesPostRequest, options) {
        return DefaultApiFp(this.configuration).apiSchedulingUpdateConwipTicketsGaugesPost(schedulingUpdateConwipTicketsGaugesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SectorsAutoOrgaGetRequest} [sectorsAutoOrgaGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsAutoOrgaPost(sectorsAutoOrgaGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSectorsAutoOrgaPost(sectorsAutoOrgaGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsClientAutoOrgaGet(options) {
        return DefaultApiFp(this.configuration).apiSectorsClientAutoOrgaGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SectorsFromTypeWithMoveXGetRequest} [sectorsFromTypeWithMoveXGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsFromTypeWithMovexPost(sectorsFromTypeWithMoveXGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSectorsFromTypeWithMovexPost(sectorsFromTypeWithMoveXGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GetAllSectorsInClientGroupRequest} [getAllSectorsInClientGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsGetAllSectorsInClientGroup(getAllSectorsInClientGroupRequest, options) {
        return DefaultApiFp(this.configuration).apiSectorsGetAllSectorsInClientGroup(getAllSectorsInClientGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} secteurId Secteur ID
     * @param {SectorsCalendarsRequest} [sectorsCalendarsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsSecteurIdCalendarsPost(secteurId, sectorsCalendarsRequest, options) {
        return DefaultApiFp(this.configuration).apiSectorsSecteurIdCalendarsPost(secteurId, sectorsCalendarsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} secteurId Secteur ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsSecteurIdDefaultCapacitiesPost(secteurId, options) {
        return DefaultApiFp(this.configuration).apiSectorsSecteurIdDefaultCapacitiesPost(secteurId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} secteurId Secteur ID
     * @param {string} importId
     * @param {SectorsImportsDelaysGetRequest} [sectorsImportsDelaysGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsSecteurIdDelaysImportIdPost(secteurId, importId, sectorsImportsDelaysGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSectorsSecteurIdDelaysImportIdPost(secteurId, importId, sectorsImportsDelaysGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} secteurId Secteur ID
     * @param {SectorsDelaysGetRequest} [sectorsDelaysGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsSecteurIdDelaysPost(secteurId, sectorsDelaysGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSectorsSecteurIdDelaysPost(secteurId, sectorsDelaysGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} secteurId Secteur ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsSecteurIdFormulasGet(secteurId, options) {
        return DefaultApiFp(this.configuration).apiSectorsSecteurIdFormulasGet(secteurId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} secteurId Secteur ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsSecteurIdMercateamAvailableOperatorsGet(secteurId, options) {
        return DefaultApiFp(this.configuration).apiSectorsSecteurIdMercateamAvailableOperatorsGet(secteurId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} secteurId Secteur ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsSecteurIdMsdParametersGet(secteurId, options) {
        return DefaultApiFp(this.configuration).apiSectorsSecteurIdMsdParametersGet(secteurId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} secteurId Secteur ID
     * @param {SectorsOperatorsGetRequest} [sectorsOperatorsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsSecteurIdOperatorsPost(secteurId, sectorsOperatorsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSectorsSecteurIdOperatorsPost(secteurId, sectorsOperatorsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} secteurId Secteur ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsSecteurIdParametersFieldsGet(secteurId, options) {
        return DefaultApiFp(this.configuration).apiSectorsSecteurIdParametersFieldsGet(secteurId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} secteurId Secteur ID
     * @param {SectorsParametersGetRequest} [sectorsParametersGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsSecteurIdParametersPost(secteurId, sectorsParametersGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSectorsSecteurIdParametersPost(secteurId, sectorsParametersGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} secteurId Secteur ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSectorsSecteurIdUnitsGet(secteurId, options) {
        return DefaultApiFp(this.configuration).apiSectorsSecteurIdUnitsGet(secteurId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LoggingGetRequest} [loggingGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiServerLogPost(loggingGetRequest, options) {
        return DefaultApiFp(this.configuration).apiServerLogPost(loggingGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} filePath
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiShuffledGet(filePath, options) {
        return DefaultApiFp(this.configuration).apiShuffledGet(filePath, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SimulationsLoadsFullGetRequest} [simulationsLoadsFullGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsAbsoluteLoadsFullPost(simulationsLoadsFullGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsAbsoluteLoadsFullPost(simulationsLoadsFullGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} ofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsAbsoluteOfsOfIdLastDateGet(ofId, options) {
        return DefaultApiFp(this.configuration).apiSimulationsAbsoluteOfsOfIdLastDateGet(ofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SimulationsCreatePostRequest} [simulationsCreatePostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsCreatePost(simulationsCreatePostRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsCreatePost(simulationsCreatePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SimulationsGanttLoadsGetRequest} [simulationsGanttLoadsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsGanttLoadsPost(simulationsGanttLoadsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsGanttLoadsPost(simulationsGanttLoadsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsGetGroupSynthesisAvailableClientIDs(options) {
        return DefaultApiFp(this.configuration).apiSimulationsGetGroupSynthesisAvailableClientIDs(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GetGroupSynthesisTableDataRequest} [getGroupSynthesisTableDataRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsGetGroupSynthesisTableData(getGroupSynthesisTableDataRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsGetGroupSynthesisTableData(getGroupSynthesisTableDataRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SimulationGetQuantitiesRequest} [simulationGetQuantitiesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsGetLoadQuantitiesPost(simulationGetQuantitiesRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsGetLoadQuantitiesPost(simulationGetQuantitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsGetSectorWLoadFormula(options) {
        return DefaultApiFp(this.configuration).apiSimulationsGetSectorWLoadFormula(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {HasSectorWLoadAndFormulaRequest} [hasSectorWLoadAndFormulaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsHasSectorWLoadAndFormula(hasSectorWLoadAndFormulaRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsHasSectorWLoadAndFormula(hasSectorWLoadAndFormulaRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SimulationsLoadTableGetRequest} [simulationsLoadTableGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsLoadTableSsePost(simulationsLoadTableGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsLoadTableSsePost(simulationsLoadTableGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {SimulationsDailyLoadsGetRequest} [simulationsDailyLoadsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdDailyLoadsPost(simulationId, simulationsDailyLoadsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdDailyLoadsPost(simulationId, simulationsDailyLoadsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {SimulationsDisabledEventsGetRequest} [simulationsDisabledEventsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdDisabledEventsPost(simulationId, simulationsDisabledEventsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdDisabledEventsPost(simulationId, simulationsDisabledEventsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {SimulationEventFieldsGetRequest} [simulationEventFieldsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdEventFieldsPost(simulationId, simulationEventFieldsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdEventFieldsPost(simulationId, simulationEventFieldsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {SimulationsEventsInfosGetRequest} [simulationsEventsInfosGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdEventsInfosPost(simulationId, simulationsEventsInfosGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdEventsInfosPost(simulationId, simulationsEventsInfosGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {SimulationsImportsGetRequest} [simulationsImportsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdImportsPost(simulationId, simulationsImportsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdImportsPost(simulationId, simulationsImportsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {SimulationsLoadGraphGetRequest} [simulationsLoadGraphGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdLoadGraphPost(simulationId, simulationsLoadGraphGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdLoadGraphPost(simulationId, simulationsLoadGraphGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {SimulationsLoadsFullGetRequest} [simulationsLoadsFullGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdLoadsFullPost(simulationId, simulationsLoadsFullGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdLoadsFullPost(simulationId, simulationsLoadsFullGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {SimulationsLoadsGetRequest} [simulationsLoadsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdLoadsPost(simulationId, simulationsLoadsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdLoadsPost(simulationId, simulationsLoadsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {SimulationsRawLoadsGetRequest} [simulationsRawLoadsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdLoadsRawPost(simulationId, simulationsRawLoadsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdLoadsRawPost(simulationId, simulationsRawLoadsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdOfsLastDoneDatePost(simulationId, body, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdOfsLastDoneDatePost(simulationId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdOfsPost(simulationId, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdOfsPost(simulationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdOpsPost(simulationId, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdOpsPost(simulationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {SimulationSectorsLoadsGetRequest} [simulationSectorsLoadsGetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsSimulationIdSectorsLoadsPost(simulationId, simulationSectorsLoadsGetRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsSimulationIdSectorsLoadsPost(simulationId, simulationSectorsLoadsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SimulationUpdateFromSchedulingRequest} [simulationUpdateFromSchedulingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSimulationsUpdateLoadFromSchedulingPost(simulationUpdateFromSchedulingRequest, options) {
        return DefaultApiFp(this.configuration).apiSimulationsUpdateLoadFromSchedulingPost(simulationUpdateFromSchedulingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiSpecificSaintGobainSullyLastUpdatesGet(options) {
        return DefaultApiFp(this.configuration).apiSpecificSaintGobainSullyLastUpdatesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdjustProdObjectiveRequest} [adjustProdObjectiveRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiStocksAdjustProdObjectivePost(adjustProdObjectiveRequest, options) {
        return DefaultApiFp(this.configuration).apiStocksAdjustProdObjectivePost(adjustProdObjectiveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {StocksGetDemandRequest} [stocksGetDemandRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiStocksGetDemandPost(stocksGetDemandRequest, options) {
        return DefaultApiFp(this.configuration).apiStocksGetDemandPost(stocksGetDemandRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {StocksGetOverloadedSectorsByArticlesRequest} [stocksGetOverloadedSectorsByArticlesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiStocksGetOverloadedSectorsByArticlesPost(stocksGetOverloadedSectorsByArticlesRequest, options) {
        return DefaultApiFp(this.configuration).apiStocksGetOverloadedSectorsByArticlesPost(stocksGetOverloadedSectorsByArticlesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {StocksSetDemandRequest} [stocksSetDemandRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiStocksSetDemandPost(stocksSetDemandRequest, options) {
        return DefaultApiFp(this.configuration).apiStocksSetDemandPost(stocksSetDemandRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiTasksPost(options) {
        return DefaultApiFp(this.configuration).apiTasksPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiUsersCheckLastLoginPost(options) {
        return DefaultApiFp(this.configuration).apiUsersCheckLastLoginPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiUsersFlushCacheGet(options) {
        return DefaultApiFp(this.configuration).apiUsersFlushCacheGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    apiUsersUpdateFromFirebasePost(options) {
        return DefaultApiFp(this.configuration).apiUsersUpdateFromFirebasePost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ValidatePasswordExpirationRouteRequest} [validatePasswordExpirationRouteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    authValidatePasswordExpirationPost(validatePasswordExpirationRouteRequest, options) {
        return DefaultApiFp(this.configuration).authValidatePasswordExpirationPost(validatePasswordExpirationRouteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BalanceLoadToCapacityRequest} [balanceLoadToCapacityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    balanceLoadToCapacity(balanceLoadToCapacityRequest, options) {
        return DefaultApiFp(this.configuration).balanceLoadToCapacity(balanceLoadToCapacityRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    bigqueryGetPost(options) {
        return DefaultApiFp(this.configuration).bigqueryGetPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProdObjectiveTransferRequest} [prodObjectiveTransferRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createProdObjectiveTransfer(prodObjectiveTransferRequest, options) {
        return DefaultApiFp(this.configuration).createProdObjectiveTransfer(prodObjectiveTransferRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DailyCapacityAndTotalCapacityByDateRequest} [dailyCapacityAndTotalCapacityByDateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getDailyCapacityAndTotalCapacityByDate(dailyCapacityAndTotalCapacityByDateRequest, options) {
        return DefaultApiFp(this.configuration).getDailyCapacityAndTotalCapacityByDate(dailyCapacityAndTotalCapacityByDateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} opId
     * @param {string} simulationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getLatestLoadEventsRowsByOpId(opId, simulationId, options) {
        return DefaultApiFp(this.configuration).getLatestLoadEventsRowsByOpId(opId, simulationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LoadRateAndRemainingCapacityRequest} [loadRateAndRemainingCapacityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getLoadRateAndRemainingCapacity(loadRateAndRemainingCapacityRequest, options) {
        return DefaultApiFp(this.configuration).getLoadRateAndRemainingCapacity(loadRateAndRemainingCapacityRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {SchedulingGetAnalyticsRequest} [schedulingGetAnalyticsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSchedulingAnalytics(simulationId, schedulingGetAnalyticsRequest, options) {
        return DefaultApiFp(this.configuration).getSchedulingAnalytics(simulationId, schedulingGetAnalyticsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingComponentsGetComponentAnalyticsRequest} [schedulingComponentsGetComponentAnalyticsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSchedulingComponentsComponentAnalytics(schedulingComponentsGetComponentAnalyticsRequest, options) {
        return DefaultApiFp(this.configuration).getSchedulingComponentsComponentAnalytics(schedulingComponentsGetComponentAnalyticsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingComponentsGetComponentDetailsRequest} [schedulingComponentsGetComponentDetailsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSchedulingComponentsComponentDetails(schedulingComponentsGetComponentDetailsRequest, options) {
        return DefaultApiFp(this.configuration).getSchedulingComponentsComponentDetails(schedulingComponentsGetComponentDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingComponentsGetComponentInitialStockRequest} [schedulingComponentsGetComponentInitialStockRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSchedulingComponentsComponentInitialStock(schedulingComponentsGetComponentInitialStockRequest, options) {
        return DefaultApiFp(this.configuration).getSchedulingComponentsComponentInitialStock(schedulingComponentsGetComponentInitialStockRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingComponentsGetComponentsCurrentStocksRequest} [schedulingComponentsGetComponentsCurrentStocksRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSchedulingComponentsComponentsCurrentStocks(schedulingComponentsGetComponentsCurrentStocksRequest, options) {
        return DefaultApiFp(this.configuration).getSchedulingComponentsComponentsCurrentStocks(schedulingComponentsGetComponentsCurrentStocksRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SchedulingComponentsGetSidebarComponentsDetailsRequest} [schedulingComponentsGetSidebarComponentsDetailsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSchedulingComponentsSidebarComponentsDetails(schedulingComponentsGetSidebarComponentsDetailsRequest, options) {
        return DefaultApiFp(this.configuration).getSchedulingComponentsSidebarComponentsDetails(schedulingComponentsGetSidebarComponentsDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} simulationId
     * @param {string} ofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSimulationsOfsParams(simulationId, ofId, options) {
        return DefaultApiFp(this.configuration).getSimulationsOfsParams(simulationId, ofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {StocksGetDemandByArticlesRequest} [stocksGetDemandByArticlesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getStocksDemandByArticles(stocksGetDemandByArticlesRequest, options) {
        return DefaultApiFp(this.configuration).getStocksDemandByArticles(stocksGetDemandByArticlesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {StocksGetObjectiveByArticlesRequest} [stocksGetObjectiveByArticlesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getStocksObjectiveByArticles(stocksGetObjectiveByArticlesRequest, options) {
        return DefaultApiFp(this.configuration).getStocksObjectiveByArticles(stocksGetObjectiveByArticlesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getStocksSectorsIdsFromGammes(options) {
        return DefaultApiFp(this.configuration).getStocksSectorsIdsFromGammes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {StocksGetStocksTableRequest} [stocksGetStocksTableRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getStocksTable(stocksGetStocksTableRequest, options) {
        return DefaultApiFp(this.configuration).getStocksTable(stocksGetStocksTableRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    importFilePost(options) {
        return DefaultApiFp(this.configuration).importFilePost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    importRowsPost(options) {
        return DefaultApiFp(this.configuration).importRowsPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    importSignedUrlGet(options) {
        return DefaultApiFp(this.configuration).importSignedUrlGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    importUpdateDataB2bPost(options) {
        return DefaultApiFp(this.configuration).importUpdateDataB2bPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    importUpdateDataPost(options) {
        return DefaultApiFp(this.configuration).importUpdateDataPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    notifyOnOplitDateParametersUpdate(options) {
        return DefaultApiFp(this.configuration).notifyOnOplitDateParametersUpdate(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    pgParserPost(options) {
        return DefaultApiFp(this.configuration).pgParserPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    sendOPsUpdatesToSGS(options) {
        return DefaultApiFp(this.configuration).sendOPsUpdatesToSGS(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MicrosoftRoleSyncRouteRequest} [microsoftRoleSyncRouteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    syncMicrosoftRoles(microsoftRoleSyncRouteRequest, options) {
        return DefaultApiFp(this.configuration).syncMicrosoftRoles(microsoftRoleSyncRouteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SyncOIDCUserRouteRequest} [syncOIDCUserRouteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    syncOIDCUser(syncOIDCUserRouteRequest, options) {
        return DefaultApiFp(this.configuration).syncOIDCUser(syncOIDCUserRouteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * @fastify/swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 8.15.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
class Configuration {
    constructor(param = {}) {
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
        this.serverIndex = param.serverIndex;
        this.baseOptions = param.baseOptions;
        this.formDataCtor = param.formDataCtor;
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    isJsonMime(mime) {
        const jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    }
}

/* tslint:disable */
/* eslint-disable */
/**
 * @fastify/swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 8.15.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
const SimulationsEventsInfosGetRequestEventTypeEnum = {
    Capa: 'capa'
};

const DEFAULT_TABLE_OF_HEADER_KEYS = [
    "of_id",
    "ref_article",
    "displayed_quantite",
    "customer",
    "order_number",
    "tags",
    "completed_ops",
    "current_op",
    "current_pdc_name",
    "nbAvanceRetard",
    "date",
    "real_theoric_date",
    "theoric_date",
    "min_oplit_date",
    "oplit_date",
    "max_oplit_date",
    "oplit_date_impact",
    "last_comment",
];
const TABLE_OF_NEEDED_SUBKEYS = {
    displayed_quantite: ["quantite_of", "quantite", "unit"],
    completed_ops: ["number_of_operations"],
    oplit_date: [
        "predicted_of_end_date",
        "remaining_of_planned_lead_time",
        "remaining_of_predicted_lead_time",
        "ops",
    ],
    current_pdc_name: ["all_of_machine_centers", "current_pdc_id"],
};
[
    ...DEFAULT_TABLE_OF_HEADER_KEYS,
    ...Object.values(TABLE_OF_NEEDED_SUBKEYS).flat(),
];

var PdpLoadEventStatus;
(function (PdpLoadEventStatus) {
    PdpLoadEventStatus["ACTIVE"] = "active";
    PdpLoadEventStatus["DISABLED"] = "disabled";
    PdpLoadEventStatus["REMOVED"] = "removed";
})(PdpLoadEventStatus || (PdpLoadEventStatus = {}));
var PdpLoadEventType;
(function (PdpLoadEventType) {
    PdpLoadEventType["ADDITION"] = "addition";
    PdpLoadEventType["OVERWRITE"] = "overwrite";
    PdpLoadEventType["MODIFICATION"] = "modification";
    PdpLoadEventType["DELETION"] = "deletion";
    PdpLoadEventType["TRANSFER"] = "transfer";
})(PdpLoadEventType || (PdpLoadEventType = {}));

//This is a simple implementation of the type of DailyRawLoadNew, just making sure that we always have the same object, and that number are not strings for ex
const prepareDailyRawLoadData = (rawData) => {
    const { client_id, import_id, secteur_id, op_id, of_id, day_date, load, collection, type, updated_at, from_children, op_sequence, op_status, raw_op_id, ref_article, ref_client, max_date_of, quantity_produced, op_name, famille, tags, op_tags, fault, quantite_op_2, quantite_of, quantite_of_besoin, quantite_cumul_rebut, quantite_op_rebut, quantite_of_disponible, fast_track, op_fast_track, order_number, customer, is_new, data_source, status_done_at, status_ongoing_at, status_available_at, prod_updated_at, is_late, internal_extra_infos, extra_infos, partition_key = "active", target_ref_article, import_type = "ofs", } = rawData;
    const cleanData = {
        client_id,
        import_id,
        secteur_id,
        op_id: op_id || "",
        of_id: of_id || op_id || "",
        day_date,
        load: +(load || 0),
        collection,
        type,
        updated_at,
        from_children: !!from_children,
        op_sequence: op_sequence === null || op_sequence === undefined
            ? 999
            : +(op_sequence || 0),
        op_status,
        raw_op_id,
        ref_article,
        ref_client,
        max_date_of,
        quantity_produced: +(quantity_produced || 0),
        op_name,
        famille,
        tags,
        op_tags,
        fault,
        quantite_op_2: +(quantite_op_2 || 0),
        quantite_of: +(quantite_of || 0),
        quantite_of_besoin: +(quantite_of_besoin || 0),
        quantite_cumul_rebut: +(quantite_cumul_rebut || 0),
        quantite_op_rebut: +(quantite_op_rebut || 0),
        quantite_of_disponible: quantite_of_disponible != null ? +quantite_of_disponible : null,
        fast_track,
        op_fast_track,
        order_number,
        customer,
        is_new: !!is_new,
        data_source: data_source || "bigquery",
        status_done_at,
        status_ongoing_at,
        status_available_at,
        prod_updated_at,
        is_late: !!is_late,
        internal_extra_infos: internal_extra_infos || {},
        extra_infos: extra_infos || {},
        partition_key,
        target_ref_article,
        import_type,
    };
    Object.keys(cleanData).forEach((key) => {
        if (cleanData[key] === undefined)
            cleanData[key] = null; //This is to avoid keys being deleted in a JSON.stringify() or when sent to server
    });
    return cleanData;
};
const dailyRawLoadKeys = Object.keys(prepareDailyRawLoadData({}));
const dailyRawLoadPrimaryKeysFields = [
    "client_id",
    "import_id",
    "secteur_id",
    "op_id",
    "day_date",
    "partition_key",
];
dailyRawLoadKeys.filter((key) => !dailyRawLoadPrimaryKeysFields.includes(key));
const rawLoadInternalExtraInfosKeys = [
    "of_name",
    "is_weight",
    "unite_op",
    "unite_of",
    "datesortie",
    "retard",
    "machine_tag_id",
    "op_duration",
    "pdc",
    "real_datelancement",
    "initial_date",
    "pdp_ignore_is_late",
    "erp_status",
    "quantite_op",
];
//This is a simple implementation of the type of DailyLoadNew, just making sure that we always have the same object, and that number are not strings for ex
const prepareDailyLoadData = (rawData) => {
    const rawPreparedData = _.omit(prepareDailyRawLoadData(rawData), ["tags", "op_tags"]);
    const { simulation_id, macro_event_id, op_order, tags, op_tags, status_done_at, status_ongoing_at, status_available_at, status_updated_at, prod_updated_at, erp_date, prod_target, } = rawData;
    const { client_id, import_id, secteur_id, op_id, of_id, day_date, load, collection, type, updated_at, from_children, op_sequence, op_status, raw_op_id, ref_article, ref_client, max_date_of, quantity_produced, op_name, famille, fault, quantite_op_2, quantite_of, fast_track, op_fast_track, order_number, customer, is_new = false, data_source, is_late, internal_extra_infos, extra_infos, partition_key, target_ref_article, import_type, quantite_of_besoin, quantite_cumul_rebut, quantite_op_rebut, quantite_of_disponible, } = rawPreparedData;
    const cleanData = {
        client_id,
        import_id,
        simulation_id,
        secteur_id,
        op_id,
        of_id,
        day_date,
        load,
        macro_event_id: macro_event_id || "",
        collection,
        type,
        updated_at,
        from_children,
        op_sequence,
        op_status,
        raw_op_id,
        ref_article,
        ref_client,
        max_date_of,
        quantity_produced,
        op_name,
        famille,
        op_order: op_order === null || op_order === undefined ? 999 : +(op_order || 0),
        tags: typeof tags === "string" ? [tags] : tags,
        fault,
        quantite_op_2,
        quantite_of,
        fast_track,
        order_number,
        customer,
        is_new,
        data_source,
        status_done_at,
        status_ongoing_at,
        status_available_at,
        status_updated_at,
        prod_updated_at,
        erp_date,
        prod_target: !!prod_target,
        is_late,
        internal_extra_infos,
        extra_infos,
        partition_key,
        target_ref_article,
        import_type,
        quantite_of_besoin,
        quantite_cumul_rebut,
        quantite_op_rebut,
        quantite_of_disponible,
        op_tags: typeof op_tags === "string" ? [op_tags] : op_tags,
        op_fast_track,
    };
    Object.keys(cleanData).forEach((key) => {
        if (cleanData[key] === undefined)
            cleanData[key] = null; //This is to avoid keys being deleted in a JSON.stringify() or when sent to server
    });
    return cleanData;
};
const dailyLoadKeys = Object.keys(prepareDailyLoadData({}));
const dailyLoadPrimaryKeysFields = [
    "client_id",
    "simulation_id",
    "secteur_id",
    "op_id",
    "day_date",
    "import_type",
    "macro_event_id",
    "partition_key",
];
dailyLoadKeys.filter((key) => !dailyLoadPrimaryKeysFields.includes(key));
const loadInternalExtraInfosKeys = [
    ...rawLoadInternalExtraInfosKeys,
    "of_delta",
    "first_active_op_theoric_date",
    "first_active_op_planned_date",
    "all_ops_done",
    "real_date",
    "real_date_delta",
    "initial_secteur_id",
    "is_smoothed",
    "smooth_idx",
    "smooth_dates",
    "cross_simulation_id",
    "is_delay",
    "production_load_strategy",
    "from_stock",
    "rescheduling_id",
    "parent_of_id",
    "first_day_duration",
    "max_daily_capa",
    "wip_order",
    "batch_id",
    "batch_name",
    "is_day_date_modified",
];
//This is a simple implementation of the type of LoadEvent, just making sure that we always have the same object, and that number are not strings for ex
const prepareLoadEventData = (rawData) => {
    const rawPreparedData = _.omit(prepareDailyLoadData(rawData), [
        "partition_key",
        "macro_event_id",
        "from_children",
        "data_source",
        "import_type",
    ]);
    const { event_id, event_type, event_updated_at, event_level, is_scheduling_simulation, event_extra_infos, 
    //we must take the raw values of numbers to avoid parsing that'll make it look like an update
    load, op_order, op_sequence, quantity_produced, quantite_op_2, quantite_of, quantite_of_besoin, quantite_cumul_rebut, quantite_op_rebut, quantite_of_disponible, prod_target, is_late, is_new, extra_infos, } = rawData;
    const { client_id, import_id, simulation_id, secteur_id, op_id, of_id, day_date, collection, type, updated_at, op_status, raw_op_id, ref_article, ref_client, max_date_of, op_name, famille, tags, op_tags, fault, fast_track, op_fast_track, order_number, customer, status_done_at, status_ongoing_at, status_available_at, status_updated_at, prod_updated_at, erp_date, } = rawPreparedData;
    let { internal_extra_infos } = rawData;
    //we inject the keys in internal_extra_infos if relevant
    loadInternalExtraInfosKeys.forEach((key) => {
        if ([null, undefined, ""].includes(rawData[key]))
            return;
        if (!internal_extra_infos)
            internal_extra_infos = {};
        internal_extra_infos[key] = rawData[key];
    });
    const cleanData = {
        client_id,
        import_id: import_id || "",
        simulation_id: simulation_id || "",
        event_id,
        event_type: event_type || "UPDATE",
        event_updated_at,
        event_level: event_level || "OP",
        is_scheduling_simulation,
        secteur_id: secteur_id,
        op_id: op_id || "",
        of_id: of_id || "",
        day_date: day_date || "",
        load: [null, undefined, ""].includes(load)
            ? undefined
            : +(load || 0),
        collection,
        type,
        updated_at,
        op_sequence: [null, undefined, ""].includes(op_sequence)
            ? undefined
            : +(op_sequence || 0),
        op_status,
        raw_op_id,
        ref_article,
        ref_client,
        max_date_of,
        quantity_produced: [null, undefined, ""].includes(quantity_produced)
            ? undefined
            : +(quantity_produced || 0),
        op_name,
        famille,
        op_order: [null, undefined, ""].includes(op_order)
            ? undefined
            : +(op_order || 0),
        tags,
        op_tags,
        fault,
        quantite_op_2: [null, undefined, ""].includes(quantite_op_2)
            ? undefined
            : +(quantite_op_2 || 0),
        quantite_of: [null, undefined, ""].includes(quantite_of)
            ? undefined
            : +(quantite_of || 0),
        quantite_of_besoin: [null, undefined, ""].includes(quantite_of_besoin)
            ? undefined
            : +(quantite_of_besoin || 0),
        quantite_op_rebut: [null, undefined, ""].includes(quantite_op_rebut)
            ? undefined
            : +(quantite_op_rebut || 0),
        quantite_cumul_rebut: [null, undefined, ""].includes(quantite_cumul_rebut)
            ? undefined
            : +(quantite_cumul_rebut || 0),
        quantite_of_disponible: [null, undefined, ""].includes(quantite_of_disponible)
            ? null
            : +(quantite_of_disponible || 0),
        fast_track,
        op_fast_track,
        order_number,
        customer,
        is_new: [null, undefined, ""].includes(is_new)
            ? undefined
            : !!is_new,
        status_done_at,
        status_ongoing_at,
        status_available_at,
        status_updated_at,
        prod_updated_at,
        erp_date,
        prod_target: [null, undefined, ""].includes(prod_target)
            ? undefined
            : !!prod_target,
        is_late: [null, undefined, ""].includes(is_late)
            ? undefined
            : !!is_late,
        internal_extra_infos,
        extra_infos,
        event_extra_infos,
    };
    Object.keys(cleanData).forEach((key) => {
        if (cleanData[key] === undefined)
            cleanData[key] = null; //This is to avoid keys being deleted in a JSON.stringify() or when sent to server
    });
    return cleanData;
};
const loadEventKeys = Object.keys(prepareLoadEventData({}));
const loadEventPrimaryKeysFields = [
    "client_id",
    "import_id",
    "simulation_id",
    "event_id",
    "of_id",
    "op_id",
    "day_date",
    "is_scheduling_simulation",
];
loadEventKeys.filter((key) => !loadEventPrimaryKeysFields.includes(key));
// New keys added at the end of all load tables (drln, dln, drlc, drlcff, dlc)
//
// Makes it easier to exclude them when spreading columns from daily_load_new for example, as
// concatenated tables have intermediary data that needs to be dealt with first
const addedLoadTableKeys = [
    "target_ref_article",
    "import_type",
    "quantite_of_besoin",
    "quantite_cumul_rebut",
    "quantite_op_rebut",
    "quantite_of_disponible",
    "op_tags",
    "op_fast_track",
];
const addedRawLoadTableKeys = [
    ...addedLoadTableKeys.filter((k) => !["quantite_of_disponible"].includes(k)),
    "quantite_of_disponible",
];
[
    ...dailyRawLoadKeys.filter(
    // Those specific keys have been added at the very end of drlc, which creates a disparity between drln and drlc
    (key) => !addedRawLoadTableKeys.includes(key)),
    "first_inserted_at",
    "last_inserted_at",
    "first_erp_date",
    ...addedRawLoadTableKeys,
];
[
    ...dailyLoadKeys.filter(
    // Those specific keys have been added at the very end of dlc, which creates a disparity between dln and dlc
    (key) => !addedLoadTableKeys.includes(key)),
    "first_inserted_at",
    "last_inserted_at",
    "first_erp_date",
    "all_secteur_ids",
    ...addedLoadTableKeys,
];

_.sortBy([
    // Default params
    { label: "PDC", field: "pdc" },
    { label: "Statut de l'opération", field: "op_status" },
    { label: "Référence article", field: "ref_article" },
    { label: "Num OF", field: "of_id" },
    //Mostly for Orano
    { label: "Date demande", field: "datelancement", type: "date" },
    { label: "Demandeur", field: "demandeur" },
    { label: "Client", field: "client" },
    { label: "Installation", field: "installation" },
    { label: "Unité productrice", field: "unite_productrice" },
    { label: "Centre de coût/EOTP", field: "centre_de_cout" },
    { label: "Code déchet", field: "code_dechet" },
    { label: "Libellé du déchet", field: "libelle_du_dechet" },
    { label: "Quantité", field: "quantite" },
    { label: "Type de saisie producteur", field: "type_saisie" },
    { label: "Masse U5", field: "masse_u5" },
    {
        label: "Date enlèvement souhaitée",
        field: "date_enlevement_souhaitee",
        type: "date",
    },
    { label: "Localisation", field: "localisation" },
    { label: "Code régime MN", field: "code_regime_mn" },
    { label: "Fiches suiveuses", field: "fiches_suiveuses" },
    { label: "Remarques", field: "remarques" },
    //Mostly for Asquini
    { label: "Phase", field: "phase" },
    { label: "Nature", field: "nature" },
    { label: "CDC", field: "cdc" },
    { label: "Article", field: "article" },
    { label: "Référence", field: "reference" },
    { label: "Libellé", field: "libelle" },
    { label: "Famille", field: "famille" },
    { label: "Ss famille", field: "ss_famille" },
    { label: "TP", field: "tp" },
    { label: "TU", field: "tu" },
    { label: "Lot", field: "lot" },
    { label: "Interne", field: "interne" },
    { label: "TT", field: "tt" },
    { label: "Statut", field: "statut" },
    { label: "Début phase charge", field: "debut_phase_charge", type: "date" },
    { label: "Fin phase", field: "fin_phase", type: "date" },
    { label: "Fin phase charge", field: "fin_phase_charge", type: "date" },
    { label: "Marge", field: "marge" },
    { label: "Quantité bonne", field: "quantite_bonne" },
    { label: "Quantité OF", field: "quantite_of" },
    // {label: "Type", field: "type"},
    { label: "Statut de l'OF", field: "statut_de_lof" },
    //Mostly for Janson
    { label: "GFP", field: "gfp" },
    { label: "N° Commande", field: "n_commande" },
    { label: "Réf. Art.", field: "ref_art" },
    { label: "Des. OF", field: "des_of" },
    { label: "OF Edité", field: "of_edite" },
    { label: "Début OF", field: "debut_of", type: "date" },
    { label: "Etat", field: "etat" },
    { label: "Code Client", field: "code_client" },
    { label: "Année", field: "annee" },
    { label: "Mois", field: "mois" },
    { label: "Semaine", field: "semaine" },
    { label: "Tete", field: "tete" },
    { label: "Jupe", field: "jupe" },
    { label: "ALU", field: "alu" },
    { label: "Désignation opération", field: "designation_operation" },
    { label: "Code commande", field: "code_commande" },
    { label: "Libellé client", field: "libelle_client" },
    { label: "Etat OF", field: "etat_of" },
    { label: "Code société", field: "code_societe" },
    { label: "Type de charge", field: "type_de_charge" },
    { label: "Nombre de pièces", field: "nb_pieces" },
    { label: "Temps de cycle", field: "tps_cycle" },
    { label: "Famille de produit", field: "famille_produit" },
    { label: "Code_famille", field: "code_famille" },
    { label: "Type", field: "type" },
    { label: "Opération", field: "operation" },
    { label: "Description", field: "description" },
    { label: "Type", field: "tps_cycle" },
    { label: "Segmentation", field: "segmentation_group" },
    { label: "Segmentation (précise)", field: "segmentation" },
    //Mostly for Berthelot
    { label: "Date début", field: "date_debut" },
    { label: "Centre de frais", field: "centre_de_frais_poste_de_charge" },
    { label: "Sous-Traitable", field: "sous_traitable" },
    { label: "Rang", field: "rang" },
    { label: "Désignation", field: "designation" },
    { label: "Qté affaire", field: "qte_affaire" },
    { label: "Délai Client", field: "delai_client" },
    { label: "Délai Planning", field: "delai_planning" },
    { label: "Numéro pointage", field: "numero_pointage" },
    { label: "Section", field: "section" },
    { label: "Précédent", field: "precedent" },
    { label: "Suivant", field: "suivant" },
    {
        label: "Ecart Délais Planning-Client",
        field: "ecart_delais_planningclient",
    },
    { label: "Ecart Delai Interne", field: "ecart_delai_interne" },
    { label: "Date Préced.", field: "date_preced" },
    { label: "Ecart", field: "ecart" },
    //Mostly for Lisi
    { label: "Division", field: "division" },
    { label: "Etablissement", field: "etablissement" },
    { label: "Num OF", field: "num_of" },
    { label: "Num OP", field: "num_op" },
    { label: "Statut OP", field: "statut_op" },
    { label: "Code Article", field: "code_article" },
    { label: "Priorité", field: "priorite" },
    { label: "Par Combien", field: "par_combien" },
    { label: "Designation OP", field: "designation_op" },
    { label: "Tps Fabrication", field: "tps_fabrication" },
    { label: "Type Statut", field: "type_statut" },
    { label: "Production Factor Group", field: "production_factor_group" },
    { label: "Type Structure", field: "type_structure" },
    { label: "EH ou KG", field: "eh_ou_kg" },
    { label: "Type OF", field: "type_of" },
    { label: "Poids", field: "poids" },
    { label: "OF ou POF", field: "of_ou_pof" },
    { label: "Num Boucle", field: "num_boucle" },
    { label: "UAP", field: "uap" },
    { label: "Macro-Gamme", field: "macrogamme" },
    //Mostly for Lisi - LIXUS
    { label: "Num OP", field: "num_operation" },
    { label: "Num OF Client", field: "num_of_client" },
    { label: "Référence Article", field: "reference_article" },
    { label: "Nom Opération", field: "nom_operation" },
    { label: "Ligne", field: "ligne" },
    //Mostly for Lisi Médical
    { field: "familles_pdp", label: "Familles PDP" },
    { field: "gap", label: "Gap" },
    { field: "centre_charge", label: "Centre de charge" },
    { field: "machine", label: "Machine" },
    { field: "code_gamme", label: "Code gamme" },
    { field: "description_1", label: "Description 1" },
    { field: "description_2", label: "Description 2" },
    { field: "description_3", label: "Description 3" },
    { field: "cellule_de_fabrication", label: "Cellule de fabrication" },
    { field: "num_operation", label: "Num opération" },
    { field: "temps_reglage", label: "Temps réglage" },
    { field: "temps_dexecution", label: "Temps d'exécution" },
    { field: "temps_machine", label: "Temps machine" },
    { field: "gere_en_temps_machine", label: "Géré en temps machine" },
    { field: "transfert", label: "Transfert" },
    { field: "charge_initiale", label: "Charge initiale" },
    //Mostly for Lisi Médical
    { field: "site_mo", label: "Site MO" },
    { field: "nom_article", label: "Nom article" },
    { field: "nombre_de_pieces", label: "Nombre de pièces" },
    //Mostly for Vaucher
    { field: "work_center", label: "POSTE DE TRAVAIL" },
    { field: "material", label: "ARTICLE" },
    { field: "material_text", label: "DESIGNATION" },
    { field: "order_category", label: "CATEGORIE D'ORDRE" },
    { field: "production_order_number", label: "ORDRE DE FABRICATION" },
    { field: "plannedorder_number", label: "ORDRE PLANIFIE" },
    { field: "operation_number", label: "OPERATION" },
    { field: "operation_status", label: "STATUT D'OPERATION" },
    { field: "components_in_place", label: "AU POSTE" },
    { field: "remaining_setup_capacity", label: "CHARGE REGLAGE RESTANTE" },
    {
        field: "remaining_processing_capacity",
        label: "CHARGE TRAITEMENT THEORIQUE RESTANTE",
    },
    {
        field: "remaining_teardown_capacity",
        label: "CHARGE DEMONTAGE RESTANTE",
    },
    { field: "earliest_start_date", label: "DATE DE DEBUT AU PLUS TOT" },
    { field: "latest", label: "DATE DE DEBUT AU PLUS TARD" },
    //Mostly for Nexteam BU AT
    { field: "id_article", label: "Id Article" },
    { field: "libelle_art", label: "Libelle Art" },
    { field: "ref", label: "REF" },
    { field: "date_debut_of", label: "Date Debut OF" },
    { field: "n_prior_couv", label: "N Prior Couv" },
    { field: "id_ofs", label: "Id Ofs" },
    { field: "qte_lancee", label: "Qte Lancee" },
    { field: "tps_prepa", label: "Tps Prepa" },
    { field: "tps_usi", label: "Tps Usi" },
    { field: "charge_h", label: "Charge (h)" },
    { field: "id_ph", label: "Id PH" },
    { field: "cdc", label: "CDC" },
    { field: "nb_associated_ofs", label: "Nb d'OFs associés" },
    { field: "famille_planif", label: "Famille Planif" },
    { field: "statut_phase", label: "Statut Phase" },
    { field: "type_charge", label: "Type charge" },
    { field: "date_fin", label: "Date fin" },
    { field: "statut_ordre", label: "Statut Ordre" },
    //Mostly for Nexteam BU Services
    { field: "ordre", label: "Ordre" },
    { field: "gestionnaire", label: "Gestionnaire" },
    { field: "gestionnaire_mrp", label: "Gestionnaire MRP" },
    { field: "type_avion", label: "Type Avion" },
    { field: "article_reference", label: "Article - Référence" },
    { field: "article_libelle", label: "Article - Libellé" },
    { field: "clients", label: "Clients" },
    { field: "of_statut_global", label: "OF - Statut Global" },
    //Mostly for Nexteam BU Engine
    { field: "statutop", label: "Statut OP" },
    { field: "statutcde", label: "Statut Commande" },
    { field: "qte_rebutee", label: "Quantité rebutée" },
    { field: "n_of", label: "N° OF" },
    // Nexteam BU Equipments Olemps
    { field: "customer", label: "Client" },
    //Mostly for Lisi Delle
    { field: "atelier", label: "Atelier" },
    { field: "zone_planif", label: "Zone planif" },
    { field: "n_fournisseur", label: "N° Fournisseur" },
    { field: "groupe_techno", label: "Groupe Techno" },
    { field: "abc", label: "ABC" },
    { field: "n_prog", label: "N° Prog" },
    { field: "type_ordre", label: "Type Ordre" },
    { field: "ope", label: "Opé." },
    { field: "tps_restant", label: "Tps restant" },
    { field: "poids_kg", label: "Poids (Kg)" },
    {
        field: "valeur_operation_incl_produits_achetes",
        label: "valeur opération incl. produits achetés",
    },
    { field: "valeur_matiere", label: "Valeur matière" },
    { field: "valeur_composant", label: "Valeur composant" },
    {
        field: "valeur_autres_articles_achetes",
        label: "valeur autres articles achetés",
    },
    { field: "nb_exec_prevu", label: "nb exec prevu" },
    { field: "datelancement_of", label: "Date de début de l'OF" },
    { field: "datesortie_of", label: "Date de fin de l'OF" },
    //Mostly for Lisi VDR
    { field: "ligne_produit", label: "Ligne produit" },
    { field: "_reference", label: "Référence" },
    { field: "matiere", label: "Matière" },
    { field: "diametre", label: "Diamètre" },
    { field: "operation_en_cours", label: "Opération en cours" },
    { field: "date_debut_op_prevue", label: "Date initiale", type: "date" },
    { field: "forme_tete", label: "Forme de tête" },
    { field: "statut_composant", label: "Statut composant" },
    { field: "longueur_sous_tete", label: "Longueur sous tête" },
    { field: "texte_operation", label: "Texte opération" },
    { field: "charge_temps_poids", label: "Charge temps/poids" },
    { field: "diam_depart", label: "Diam. départ" },
    //Mostly for J3L
    { field: "famille_pic", label: "Famille PIC" },
    { field: "site_de_production", label: "Site de production" },
    //Mostly for LISI COI
    { field: "article_type", label: "Article type" },
    { field: "material_availability", label: "Material Availability" },
    //Mostly for LISI BAR
    { field: "ref_compl", label: "Référence" },
    { field: "statut_ope", label: "Statut Opération" },
    { field: "groupe_accord", label: "Groupe Accord" },
    { field: "donneur_ordre", label: "Donneur Ordre" },
    //Mostly for ADDEV, demo
    { field: "ferme_vs_prev", label: "Ferme vs. Prévisionnel" },
    { field: "lien_avec_commande", label: "Lien avec commande" },
    { field: "statut_mp", label: "Statut MP" },
    //Mostly for Tecalemit
    { field: "statut_2", label: "Statut 2" },
    { field: "refaffdes", label: "Programme client" },
    { field: "refcust", label: "Référence client" },
    //Mostly for Horlyne
    { field: "client_nom", label: "Nom Client" },
    //Mostly for Varinor
    { field: "typologie", label: "Typologie" },
    { field: "masse_bd_est", label: "Masse BD Est." },
    { field: "alliages", label: "Alliages" },
    { field: "dimensions", label: "Dimensions" },
    { field: "n_coulee", label: "N° Coulée" },
    { field: "racine_of", label: "Racine OF" },
    { field: "couleur", label: "Couleur" },
    { field: "prio", label: "Prio" },
    //Others
    { field: "is_late", label: "En retard ?" },
    { field: "group_key", label: "Clé de grouping" },
    { field: "order_number", label: "Numéro de commande" },
], "label");

/**
 * Calculate holidays in a year
 * @param an the year
 * @returns the list of holidays in format YYYY-MM-DD
 */
const JoursFeries = function (an) {
    const JourAn = new Date(an, 0, 1);
    const FeteTravail = new Date(an, 4, 1);
    const Victoire1945 = new Date(an, 4, 8);
    const FeteNationale = new Date(an, 6, 14);
    const Assomption = new Date(an, 7, 15);
    const Toussaint = new Date(an, 10, 1);
    const Armistice = new Date(an, 10, 11);
    const Noel = new Date(an, 11, 25);
    const G = an % 19;
    const C = Math.floor(an / 100);
    const H = (C - Math.floor(C / 4) - Math.floor((8 * C + 13) / 25) + 19 * G + 15) % 30;
    const I = H -
        Math.floor(H / 28) *
            (1 -
                Math.floor(H / 28) *
                    Math.floor(29 / (H + 1)) *
                    Math.floor((21 - G) / 11));
    const J = (an * 1 + Math.floor(an / 4) + I + 2 - C + Math.floor(C / 4)) % 7;
    const L = I - J;
    const MoisPaques = 3 + Math.floor((L + 40) / 44);
    const JourPaques = L + 28 - 31 * Math.floor(MoisPaques / 4);
    const Paques = new Date(an, MoisPaques - 1, JourPaques);
    const LundiPaques = new Date(an, MoisPaques - 1, JourPaques + 1);
    const Ascension = new Date(an, MoisPaques - 1, JourPaques + 39);
    const Pentecote = new Date(an, MoisPaques - 1, JourPaques + 49);
    const LundiPentecote = new Date(an, MoisPaques - 1, JourPaques + 50);
    return [
        JourAn,
        Paques,
        LundiPaques,
        FeteTravail,
        Victoire1945,
        Ascension,
        Pentecote,
        LundiPentecote,
        FeteNationale,
        Assomption,
        Toussaint,
        Armistice,
        Noel,
    ].map((date) => moment(date).format("YYYY-MM-DD"));
};
const momentIsHoliday = (date) => {
    const holidays = JoursFeries(date.year());
    const formattedDate = date.format("YYYY-MM-DD");
    return holidays.includes(formattedDate);
};
const momentIsWeekend = (date) => [6, 7].includes(date.isoWeekday());
/**
 * handler with common logic to be passed for date-related functions
 * this is intended to work for function which first argument is a date passed as a string or a moment object
 * this handler will invoke the original function with the argument as a moment object to simplify further logic
 */
const dateHandler = {
    apply: (target, thisArg, argumentsList) => {
        const [date] = argumentsList;
        const momentDate = moment(date);
        if (!moment(momentDate).isValid())
            return false;
        // return the original invoke with
        return target.apply(thisArg, [momentDate, ...argumentsList.slice(1)]);
    },
};
new Proxy(momentIsHoliday, dateHandler);
new Proxy(momentIsWeekend, dateHandler);

var ConwipTicketsGaugeFields;
(function (ConwipTicketsGaugeFields) {
    ConwipTicketsGaugeFields["Underload"] = "underload_tickets_count";
    ConwipTicketsGaugeFields["Ideal"] = "default_ideal_tickets_count";
    ConwipTicketsGaugeFields["OverloadModerate"] = "overload_moderate_tickets_count";
    ConwipTicketsGaugeFields["OverloadCritical"] = "overload_critical_tickets_count";
})(ConwipTicketsGaugeFields || (ConwipTicketsGaugeFields = {}));

var SchedulingComponentsEntryTypes;
(function (SchedulingComponentsEntryTypes) {
    SchedulingComponentsEntryTypes["CustomersOrders"] = "customers_orders";
    SchedulingComponentsEntryTypes["PurchaseOrders"] = "purchase_orders";
    SchedulingComponentsEntryTypes["OfDebit"] = "of_debit";
    SchedulingComponentsEntryTypes["OfCredit"] = "of_credit";
    SchedulingComponentsEntryTypes["PofDebit"] = "pof_debit";
    SchedulingComponentsEntryTypes["PofCredit"] = "pof_credit";
})(SchedulingComponentsEntryTypes || (SchedulingComponentsEntryTypes = {}));

var ImportFlowLogLevels;
(function (ImportFlowLogLevels) {
    ImportFlowLogLevels["INFO"] = "INFO";
    ImportFlowLogLevels["WARN"] = "WARN";
    ImportFlowLogLevels["ERROR"] = "ERROR";
})(ImportFlowLogLevels || (ImportFlowLogLevels = {}));

var ApiBackend;
(function (ApiBackend) {
    ApiBackend["DATA"] = "data";
    ApiBackend["FRONT"] = "front";
    ApiBackend["INTERNAL"] = "internal";
    ApiBackend["IMPORT"] = "import";
})(ApiBackend || (ApiBackend = {}));

class Result {
    static success(payload) {
        return [payload, null];
    }
    static error(error) {
        return [null, error];
    }
    static errorWithContext(error, errorContext) {
        return [errorContext, error];
    }
    static isError(result) {
        return result[1] !== null;
    }
    static isSuccess(result) {
        return result[1] === null;
    }
    static unwrap(result, errorCallback = rethrow) {
        if (Result.isSuccess(result)) {
            return result[0];
        }
        errorCallback(result[1], result[0]);
        return null;
    }
}
function rethrow(err, ctx) {
    throw err;
}

// This is our wrapper. Feel free to edit it, openapi generators won't touch this one.
function wrapApiClient(client) {
    const wrappedClient = {};
    const prototype = Object.getPrototypeOf(client);
    const methodNames = Object.getOwnPropertyNames(prototype).filter((key) => {
        const descriptor = Object.getOwnPropertyDescriptor(prototype, key);
        return key !== "constructor" && typeof (descriptor === null || descriptor === void 0 ? void 0 : descriptor.value) === "function";
    });
    for (const key of methodNames) {
        const origMethod = client[key];
        if (typeof origMethod === "function") {
            wrappedClient[key] = function (...args) {
                var _a;
                try {
                    const result = origMethod.apply(this, args);
                    if (result && typeof result.then === "function") {
                        return result
                            .then((response) => Result.success(response.data))
                            .catch((error) => {
                            var _a;
                            const context = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
                            if (!context)
                                return Result.error(error);
                            return Result.errorWithContext(error, context);
                        });
                    }
                    else {
                        return Promise.resolve(Result.success(result));
                    }
                }
                catch (error) {
                    const context = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
                    if (!context)
                        return Promise.resolve(Result.error(error));
                    return Promise.resolve(Result.errorWithContext(error, context));
                }
            }.bind(client);
        }
    }
    // Copy over any own properties from the client instance
    Object.assign(wrappedClient, client);
    return wrappedClient;
}
function buildOplitClient(...args) {
    return wrapApiClient(new DefaultApi(...args));
}

export { Configuration, DefaultApi, DefaultApiAxiosParamCreator, DefaultApiFactory, DefaultApiFp, DefaultApi as OplitApi, SimulationsEventsInfosGetRequestEventTypeEnum, buildOplitClient };
